
/* eslint-disable no-undef */
/* eslint-disable camelcase */
import { sizes } from 'src/styles/Media.styled';
import { getWeekendCountBetweenDates } from 'src/utils/dateUtils.js';
import {
    ALL_USER_ROLES,
    CTA_IDS,
    ALLDISTRICTS,
    ALLTERRITORIES,
    ERRORDETAILS,
    EQUITY_USER_PAGE_VISIBILITY_RULE,
    US_COUNTRY_CODE,
    SR_USER_ROLE,
    CS_USER_ROLE,
    CSR_USER_ROLE,
    DM_USER_ROLE,
    FIM_USER_ROLE,
    FIA_USER_ROLE,
    SM_USER_ROLE,
    VISIBLE,
    US_CURRENCY_CODE,
    US_LANGUAGE_CODE,
    BASESITEID,
} from 'src/constants/appConstants';
import { createTransform } from 'redux-persist';
import {
    resetSurgeryDetails,
    reSetProgressBarStatus,
    resetCreateOrUpdateSurgery,
} from 'src/pages/scheduleSurgery/redux/actions/index.js';
import { resetReportUsageStates } from 'src/pages/reportUsage/redux/action/actionCreators';
import {
    resetAppliedOrderListFilter,
    resetOrderListFilter,
    resetAwaitingToggle,
    resetAwaitingToggleMobile,
    restoreOrderFilterSnapshot,
} from 'src/pages/orders/redux/actions/index';
import { resetCalendarSelectedDate } from 'src/pages/home/redux/actions/index';
import {
    resetAccountFilterState,
    restoreAccountFilterState,
    resetPhysicianFilterState,
    restorePhysicianFilterState,
} from 'src/pages/more/redux/actions';
import { routes } from 'src/constants/routes';
import { numFormatObj as equityNumFormatObj } from 'src/pages/equity/components/common/utils/eventHandlerUtil';
import { getPriceInNumberDataType } from 'src/pages/reportUsage/utils/dataModificaionUtil';
import { numFormatObj as consignmentReturnNumFormatObj } from 'src/pages/consignmentReturn/utils/eventHandlerUtil';
import {
    numFormatObj as consignmentBillingNumFormatObj,
    priceFormatObj as consignmentBillingPriceFormatObj,
} from 'src/pages/consignmentBilling/utils/eventHandlerUtil';
import { priceFormatObj as reportUsagePriceFormatObj } from 'src/pages/reportUsage/utils/eventHandlerUtil';
import { priceFormatObj as equityPriceFormatObj } from 'src/pages/equity/components/cart/priceOverride/utils/eventHandlerUtil';
import i18n from 'src/i18n.js';
const t = (key) => i18n.t(key);
import { logoutSSO } from 'src/common/redux/actions';
import { ERROR_BOUNDARY_STATUS } from 'src/constants/appConstants';

// extract only date
// export const extractDateFromISOString = (date) => {
//     return date && date.substring(0, 10);
// };

// Convert date object to ISO string
export const convertDateToISOStringOld = (date) => {
    return date ? date.toISOString().substring(0, 19) + 'Z' : '';
};

// Check if the current site is OUS (Outside US)
export const isOusSite = () => {
    return window.location.hostname.includes('.ous.');
};

// Select WCMS host name based on hostname
// eslint-disable-next-line no-undef
export const getWcmsHostName = () => {
    const hostname = window.location.hostname;
    // Check if URL contains 'ous' (e.g., test.ous.mycase.medtronic.com)
    if (hostname.includes('.ous.') && process.env.WCMS_HOST_NAME_OUS) {
        // eslint-disable-next-line no-undef
        return process.env.WCMS_HOST_NAME_OUS;
    }
    // eslint-disable-next-line no-undef
    return process.env.WCMS_HOST_NAME;
};

export const convertDateToISOString = (dateObject, type) => {
    // Treat clearing / empty input as "no date"
    if (dateObject === null || dateObject === undefined || dateObject === '' || !type) {
        return '';
    }

    // If already in the expected "YYYY-MM-DDTHH:mm:ssZ" format, return as-is
    if (typeof dateObject === 'string' && dateObject.length === 20 && dateObject.endsWith('Z')) {
        return dateObject;
    }

    const zeroTimeDateBrowser = dateObject instanceof Date
        ? new Date(dateObject.getTime())
        : new Date(dateObject);

    if (isNaN(zeroTimeDateBrowser.getTime())) {
        return '';
    }
    if (type === 'start') {
        zeroTimeDateBrowser.setHours(0, 0, 0, 0);
    } else if (type === 'end') {
        zeroTimeDateBrowser.setHours(23, 59, 59, 999);
    }
    return zeroTimeDateBrowser.toISOString().substring(0, 19) + 'Z';
};
export const convertObjectToQueryParams = (
    payloadObject,
    isFalsyValueRequired = false
) => {
    let param = '';
    for (let key in payloadObject) {
        if (payloadObject[key] !== undefined || isFalsyValueRequired) {
            const value = encodeURIComponent(
                payloadObject[key] !== undefined
                    ? payloadObject[key]
                    : ''
            );
            param += `${key}=${value}&`;
        }
    }
    return param.slice(0, -1);
};
export const expandCollapse = (
    expandedProducts,
    products,
    lastClickedAction
) => {
    let result = '';
    result =
        expandedProducts?.size === 0
            ? 'expand'
            : expandedProducts?.size === products?.length
                ? 'collapse'
                : lastClickedAction === 'expand'
                    ? 'collapse'
                    : 'expand';
    return result;
};

export const accountNumberZeroTrimmer = (accountNumberString) => {
    try {
        return accountNumberString?.replace(/^0+/, '');
    } catch (error) {
          logErrorToConsole(error);
    }
};

export const dynamicPluralization = (singularWord, pluralWord, number) => {
    return number > 1 ? pluralWord : singularWord;
};

export const dynamicLandingPageCalendarView = () => {
    let lastSelDLPCalView = localStorage.getItem('lastSelDLPCalView');

    const checkIfMobileDevice = () => {
        return window.innerWidth <= sizes.mobileDevice || isMobileDevice();
    };
    if (lastSelDLPCalView && !checkIfMobileDevice()) {
        return lastSelDLPCalView;
    } else if (lastSelDLPCalView && checkIfMobileDevice()) {
        return lastSelDLPCalView === 'List' ? 'Week' : lastSelDLPCalView;
    } else {
        return 'Month';
    }
};

export const dynamicLandingPageVisibleDateRange = () => {
    const selectedDateFormatted = new Date(new Date().setHours(0, 0, 0, 0));
    let visibleDateRange = [];

    const startMonthDate = new Date(
        selectedDateFormatted.getFullYear(),
        selectedDateFormatted.getMonth(),
        1,
        0,
        0,
        0
    );
    visibleDateRange.push(startMonthDate);

    const endMonthDate = new Date(
        selectedDateFormatted.getFullYear(),
        selectedDateFormatted.getMonth() + 1,
        0,
        23,
        59,
        59
    );
    visibleDateRange.push(endMonthDate);

    return visibleDateRange;
};

export const convertTime24To12 = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours >= 12 ? hours % 12 || 12 : hours === 0 ? '12' : hours;
    hours = hours < 10 ? '0' + hours : hours;
    // minutes = minutes == 0 ? '0' + minutes : minutes;
    minutes = minutes == 0 || minutes < 10 ? '0' + minutes : minutes;
    return hours + ':' + minutes + ' ' + ampm;
};

// Default actions for list views
export const getDefaultCTAId = (rowData, fromCalendar, cardActionView,isFromOrderHistory) => {
    if ((!rowData || !rowData.callToActionList) && !fromCalendar) return;

    let defaultCTA = '';
    switch (rowData.orderStatusDescription) {
        case t('orders.orderStatuses.draftNotSubmitted'):
            defaultCTA = 'CTA_005'; // 'Edit';
            break;
        case t('orders.orderStatuses.usagePending'):
            defaultCTA = 'CTA_012'; // 'Report Usage';
            break;
        case t('orders.orderStatuses.paymentInformationNeeded'):
            defaultCTA = 'CTA_013'; // 'Report Payment';
            break;
        case t('orders.orderStatuses.submittedPendingPriceOverride'):
            defaultCTA = 'CTA_013'; // 'Report Payment'
            break;
        case t('orders.orderStatuses.usageCompleted'):
            defaultCTA = 'CTA_001'; // View
            break;
        case t('orders.orderStatuses.partialShipped'):
            defaultCTA = 'CTA_005'; // Edit
            break;
        case t('orders.orderStatuses.shippedComplete'):
            defaultCTA = 'CTA_005'; // Edit
            break;
        case t('orders.orderStatuses.usageSubmittedPendingInvoice'):
            defaultCTA = 'CTA_018'; // 'View Usage Reports';
            break;
        case t('orders.orderStatuses.billingIssues'):
            defaultCTA = 'CTA_014'; // 'Billing Summary';
            break;
        case t('orders.orderStatuses.fullyInvoiced'):
            defaultCTA = 'CTA_009'; // 'Request Invoice';
            break;
        case t('orders.orderStatuses.inProcess'):
            defaultCTA = 'CTA_005'; // 'Edit';
            break;
        // case 'Awaiting Return':
        //     defaultCTA = 'CTA_011'; // 'View Adjustments';
        //     break;
        // case 'Partial Return':
        //     defaultCTA = 'CTA_011'; // 'View Adjustments';
        //     break;
        // case 'Complete':
        //     defaultCTA = 'CTA_011'; // 'View Adjustments';
        //     break;
        default:
            if (fromCalendar === true) {
                return cardActionView[0].ctaId;
            } else {
                return rowData.callToActionList[0]?.ctaId;
            }
    }

    if (
        (rowData.callToActionList || []).find(
            (action) => action.ctaId === defaultCTA
        )
    ) {
        return defaultCTA;
    } else if (
        (cardActionView || []).find((action) => action.ctaId === defaultCTA)
    ) {
        return defaultCTA;
    } else if (
        (cardActionView || []).find((action) => action.ctaId !== defaultCTA)
    ) {
        return cardActionView[0]?.ctaId;
    } else if (rowData?.callToActionList) {
        return rowData.callToActionList[0]?.ctaId;
    } else if (cardActionView) {
        return cardActionView[0].ctaId;
    } else {
        return null;
    }
};

export const orderStatusColorCode = (orderStatus) => {
    const colors = {
        [t('orders.orderStatuses.usagePending')]: '#F9D78C',
        [t('orders.orderStatuses.usageCompleted')]: '#F9D78C',
        [t('orders.orderStatuses.draftNotSubmitted')]: '#A6A6A6',
        [t('orders.orderStatuses.shippedComplete')]: '#14853D',
        [t('orders.orderStatuses.billingIssues')]: '#EB475B',
        [t('orders.index.awaitingPO')]: '#EB475B',
        [t('orders.orderStatuses.fullyInvoiced')]: '#14853D',
        [t('orders.orderStatuses.inProcess')]: '#0DDCB9',
        [t('orders.orderStatuses.usageSubmittedPendingInvoice')]: '#0DDCB9',
        [t('orders.orderStatuses.submittedPendingPriceOverride')]: '#E26D38',
        [t('orders.orderStatuses.partialShipped')]: '#7ECA2A',
        [t('orders.orderStatuses.deliveryBlock')]: '#E26D38',
        [t('orders.orderStatuses.billingBlock')]: '#E26D38',
        [t('orders.orderStatuses.billingSubmittedPendingInvoice')]: '#5E981F',
        'Billing Submitted pending invoice': '#5E981F',
        [t('orders.orderStatuses.awaitingReturn')]: '#0DDCB9',
        [t('orders.orderStatuses.partialReturn')]: '#7DC929',
        Completed: '#14853D',
        [t('orders.orderStatuses.complete')]: '#14853D',
        [t('orders.orderStatuses.cancelled')]: '#A8A8A8',
    };
    return colors[orderStatus];
};

export const getReportUsageResourceType = (orderStatus, ctaID) => {
    if (
        ctaID === CTA_IDS.editOrder ||
        orderStatus === t('orders.orderStatuses.draftNotSubmitted')
    ) {
        return 'draft';
    } else if (
        ctaID === CTA_IDS.reportPayment ||
        orderStatus === t('orders.orderStatuses.paymentInformationNeeded')
    ) {
        return 'reportPayment';
    } else {
        return 'reportUsage';
    }
};

export const checkSurgeryDate = (selectedDate, numOfDays) => {
    let currentDate = new Date();
    let currentStartofDay = currentDate.setHours(0, 0, 0, 0);
    currentStartofDay = new Date(currentStartofDay);
    let futureDate = new Date(
        currentStartofDay.setDate(currentDate.getDate() + numOfDays)
    );

    let weekendsFutureDate = new Date(futureDate).setDate(
        futureDate.getDate() +
        getWeekendCountBetweenDates(new Date(), futureDate)
    );
    return numOfDays === 3
        ? selectedDate < weekendsFutureDate
        : selectedDate < futureDate;
};
export const sortSetItemDetails = (parameter, isNumber = false) => {
    const { data, objectField, searchField, ascending } = parameter;
    const sortedArray = data?.[objectField]?.sort((a, b) => {
        let isNumbers = isNumber;
        isNumbers =
            isNaN(a[searchField]) || isNaN(b[searchField]) ? false : true;
        if (isNumbers) {
            return Number(a[searchField].replace(/-/g, '')) >
                Number(b[searchField].replace(/-/g, ''))
                ? ascending
                    ? 1
                    : -1
                : Number(b[searchField].replace(/-/g, '')) >
                    Number(a[searchField].replace(/-/g, ''))
                    ? ascending
                        ? -1
                        : 1
                    : 0;
        }
        return a[searchField] > b[searchField]
            ? ascending
                ? 1
                : -1
            : b[searchField] > a[searchField]
                ? ascending
                    ? -1
                    : 1
                : 0;
    });
    return sortedArray;
};
export const getObjectFromArray = (array, objectField, elementId) => {
    return array.find((element) => element[objectField] === elementId);
};
export const anyAppliedOrCheckedFilter = (filters) => {
    if (
        (filters?.filter(
            (e) =>
                ((e.name && e.name != 'All') ||
                    (e.description && e.description != 'All') ||
                    (e.orderTypeName && e.orderTypeName != 'All')) &&
                e.isChecked === true
        ) || [])?.length > 0
    ) {
        return true;
    } else {
        return false;
    }
};

export const anyAppliedFilterCheckDefault = (filters, defaultValue) => {
    if (
        (filters?.filter(
            (e) => e.isChecked === true && e.orderTypeCode !== 'All' && e.statusCode !== defaultValue
        ) || [])?.length > 0
    ) {
        return true;
    } else {
        return false;
    }
};

export const removeEmptyFieldsFromObject = (data) => {
    const returnData = {
        ...data,
    };
    if (returnData?.surgeryDetails?.physicianId === 'unknown') {
        returnData.surgeryDetails.physicianId = '';
    }
    for (let key in returnData) {
        if (typeof returnData[key] === 'string' && !returnData[key])
            delete returnData[key];

        // if(typeof(returnData[key]) === 'string' )
    }
    return returnData;
};

export const getQuantityCount = (data) => {
    return data.reduce(
        (acc, curr) => acc + parseInt(curr.quantity ? curr.quantity : 0),
        0
    );
};

export const isMobileDevice = () => {
    var check = false;
    (function (a) {
        if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                a
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                a.substr(0, 4)
            )
        )
            check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

export const isIOSiPhoneDevice = () =>
    navigator.userAgent && /iPhone/.test(navigator.userAgent);

export const getAdditionalTextareaLimit = (noteVal) => {
    const newLines = noteVal.match(/\n/g);
    let addition = 0;
    if (newLines != null) {
        addition = newLines.length;
    }
    return addition;
};

export const convertDurationToText = (value) => {
    const duration = value.split(':');
    const hour = duration[0];
    const minute = duration[1];

    const durationText =
        (+hour <= 0 ? '' : +hour > 1 ? `${+hour} hours` : `${+hour} hour`) +
        ' ' +
        (+minute <= 0
            ? ''
            : +minute > 1
                ? `${minute} minutes`
                : `${minute} minute`);

    return durationText;
};

export const filterPhysicianList = (data) => { 
    if (!Array.isArray(data)) {
        return [];
    }
    const filterList = data.filter(
        (element) =>
            element.physicianFirstName != 'Other' &&
            element.physicianLastName != 'Physician'
    );
    return filterList;
};

export const filterProductsWithQuantityGreaterThanZero = (products) => {
     if (!Array.isArray(products)) {
        return [];
    }
    
    let clonedProducts = [...products];
    let productsList = [];
    clonedProducts = clonedProducts.filter((product) => product.quantity > 0);
    clonedProducts &&
        clonedProducts.map((product) => {
            if (
                product &&
                product.quantity &&
                Object.prototype.hasOwnProperty.call(product, 'children')
            ) {
                product.children = product.children?.filter(
                    (children) => children.quantity > 0
                ) || [];
                productsList.push({
                    ...product,
                });
            } else {
                product.quantity
                    ? productsList.push({
                        ...product,
                    })
                    : null;
            }
        });
    return productsList;
};

export const navLinkSelectHandler = (
    dispatch,
    setActiveNavLink,
    name,
    isSelected
) => {
    switch (name) {
        case 'calendar':
            dispatch(
                setActiveNavLink({
                    dashboard: false,
                    calendar: true,
                    admin: false,
                    orders: false,
                    alerts: false,
                    inventory: false,
                    more: false,
                    deniedUsageOverrides: false,
                    productGuide: false,
                })
            );

            break;
        case 'admin':
            dispatch(
                setActiveNavLink({
                    dashboard: false,
                    calendar: false,
                    admin: true,
                    orders: false,
                    alerts: false,
                    inventory: false,
                    more: false,
                    deniedUsageOverrides: false,
                    productGuide: false,
                })
            );
            break;
        case 'orders':
            dispatch(
                setActiveNavLink({
                    dashboard: false,
                    calendar: false,
                    admin: false,
                    orders: true,
                    alerts: false,
                    inventory: false,
                    more: false,
                    deniedUsageOverrides: false,
                    productGuide: false,
                   
                })
            );
            break;
        case 'alerts':
            dispatch(
                setActiveNavLink({
                    dashboard: false,
                    calendar: false,
                    admin: false,
                    orders: false,
                    alerts: true,
                    inventory: false,
                    more: false,
                    deniedUsageOverrides: false,
                    productGuide: false
                })
            );
            break;
        case 'inventory':
            dispatch(
                setActiveNavLink({
                    dashboard: false,
                    calendar: false,
                    admin: false,
                    orders: false,
                    alerts: false,
                    inventory: true,
                    more: false,
                    deniedUsageOverrides: false,
                    productGuide: false
                })
            );
            break;
        case 'more':
            window.innerWidth <= sizes.smalDevice &&
                dispatch(
                    setActiveNavLink({
                        ...isSelected,
                        more: !isSelected.more,
                    })
                );
            break;
        case 'dashboard':
            dispatch(
                setActiveNavLink({
                    dashboard: true,
                    calendar: false,
                    admin: false,
                    orders: false,
                    alerts: false,
                    inventory: false,
                    more: false,
                    deniedUsageOverrides: false,
                    productGuide: false
                })
            );
            break;
        case 'deniedUsageOverrides':
            dispatch(
                setActiveNavLink({
                    dashboard: false,
                    calendar: false,
                    admin: false,
                    orders: false,
                    alerts: false,
                    inventory: false,
                    more: false,
                    deniedUsageOverrides: true,
                    productGuide: false
                })
            );
            break;
        case 'productGuide':
            dispatch(
                setActiveNavLink({
                    dashboard: false,
                    calendar: false,
                    admin: false,
                    orders: false,
                    alerts: false,
                    inventory: false,
                    more: false,
                    deniedUsageOverrides: false,
                    productGuide: true
                })
            );
            break;
        default:
            break;
    }
};

export const navigateWithBusinessLogic = (
    setDeniedOverrideClicked,
    event,
    path,
    selectOption,
    surgeryCUInProgress,
    settingUpdateInProgress,
    dispatch,
    setRoutePathForSSUnsavedChangesPopUp,
    setScheduleSurgeryUnsavedChangesPopUp,
    history,
    navLinkSelectHandler,
    setActiveNavLink,
    clicked,
    setShowUnsavedReportUsageChangesPopUp,
    isInReportUsageSubmitScreen,
    isCancelUsageSubmitted,
    equityCUInProgress,
    setRoutePathForEquityUnsavedChangesPopUp,
    setEquityUnsavedChangesPopUp,
    consignmentCUInProgress,
    setRoutePathForConsignmentUnsavedChangesPopUp,
    setConsignmentUnsavedChangesPopUp,
    setRoutePathForAnnouncementUnsavedChangesPopUp,
    setAnnouncementUnsavedChangesPopUp,
    setAccountUnsavedChangesPopUp,
    setRoutePathForAccountUnsavedChangesPopUp,
    setLinksUnsavedChangesPopUp,
    setRoutePathForLinksUnsavedChangesPopUp,
    setPhysiciansUnsavedChangesPopUp,
    setRoutePathForPhysiciansUnsavedChangesPopUp,
    setProxiesUnsavedChangesPopUp,
    setRoutePathForProxiesUnsavedChangesPopUp,
    pageName,
    routePathForTemplatesUnsavedChangesPopUp,
    setTemplatesUnsavedChangesPopUp,
    setRoutePathForTemplatesUnsavedChangesPopUp,
    setProductGuideUnsavedChangesPopUp,
    setRoutePathForProductGuideUnsavedChangesPopUp,
    products,
    selectedBrands,
    subCategoryRefineData, // defaultView, // isCalendarSharing, // notificationSettings
    settingsValue,
    productGuideValue,
    setReceiveSetUnsavedChangesPopup,
    setRoutePathForReceiveSetUnsavedChangesPopUp,
    receiveSetsCUInProgress,
    isInReceiveSetSubmitScreen,
    consignmentAddCUInProgress,
    setConsignmentAddUnsavedChangesPopUp,
    setRoutePathForConsignmentAddUnsavedChangesPopUp
) => {
    event.preventDefault();
    if (typeof path == 'function') {
        path();
    }
    if (clicked && selectOption) clicked();
    if (selectOption === 'deniedUsageOverrides') {
        dispatch(setDeniedOverrideClicked(true));
    } else {
        dispatch(setDeniedOverrideClicked(false));
    }

    const employeeRole = getUserDetails();

    if (
        (window.location.pathname.includes('scheduleSurgery') ||
            window.location.pathname.includes('modifySurgery')) &&
        surgeryCUInProgress
    ) {
        dispatch(
            setRoutePathForSSUnsavedChangesPopUp({
                path: path,
                selectOption: selectOption,
            })
        );
        dispatch(setScheduleSurgeryUnsavedChangesPopUp(true));
    } else if (
        (window.location.pathname.includes('equity') ||
            window.location.pathname.includes('modifyEquity')) &&
        equityCUInProgress
    ) {
        dispatch(
            setRoutePathForEquityUnsavedChangesPopUp({
                path: path,
                selectOption: selectOption,
            })
        );
        dispatch(setEquityUnsavedChangesPopUp(true));
    } else if (
        (window.location.pathname.includes('consignmentBilling') ||
            window.location.pathname.includes('inventory')) &&
        consignmentCUInProgress
    ) {
        dispatch(
            setRoutePathForConsignmentUnsavedChangesPopUp({
                path: path,
                selectOption: selectOption,
            })
        );
        dispatch(setConsignmentUnsavedChangesPopUp(true));
    } else if (
        window.location.pathname.includes('consignmentReturn') &&
        consignmentCUInProgress
    ) {
        dispatch(
            setRoutePathForConsignmentUnsavedChangesPopUp({
                path: path,
                selectOption: selectOption,
            })
        );
        dispatch(setConsignmentUnsavedChangesPopUp(true));
    } else if (
        window.location.pathname.includes('announcements') &&
        settingUpdateInProgress
    ) {
        if (path.includes('http')) {
            window.location.href = path;
        } else if (window.location.pathname !== path) {
            history.push({
                ...getRoutePathWithParams(path),
            });
        }
        dispatch(
            setRoutePathForAnnouncementUnsavedChangesPopUp({
                path: path,
                selectOption: selectOption,
            })
        );
        // dispatch(setAnnouncementUnsavedChangesPopUp(true));
    } else if (
        window.location.pathname.includes('accounts') &&
        settingUpdateInProgress
    ) {
        if (path.includes('http')) {
            window.location.href = path;
        } else if (window.location.pathname !== path) {
            history.push({
                ...getRoutePathWithParams(path),
            });
        }
        dispatch(
            setRoutePathForAccountUnsavedChangesPopUp({
                path: path,
                selectOption: selectOption,
            })
        );
        // dispatch(setAccountUnsavedChangesPopUp(true));
    } else if (
        window.location.pathname.includes('links') &&
        settingUpdateInProgress
    ) {
        if (path.includes('http')) {
            window.location.href = path;
        } else if (window.location.pathname !== path) {
            history.push({
                ...getRoutePathWithParams(path),
            });
        }
        dispatch(
            setRoutePathForLinksUnsavedChangesPopUp({
                path: path,
                selectOption: selectOption,
            })
        );
        // dispatch(setLinksUnsavedChangesPopUp(true));
    } else if (
        window.location.pathname.includes('physicians') &&
        settingUpdateInProgress
    ) {
        if (path.includes('http')) {
            window.location.href = path;
        } else if (window.location.pathname !== path) {
            history.push({
                ...getRoutePathWithParams(path),
            });
        }
        dispatch(
            setRoutePathForPhysiciansUnsavedChangesPopUp({
                path: path,
                selectOption: selectOption,
            })
        );
        // dispatch(setPhysiciansUnsavedChangesPopUp(true));
    } else if (
        window.location.pathname.includes('proxies') &&
        settingUpdateInProgress
    ) {
        if (path.includes('http')) {
            window.location.href = path;
        } else if (window.location.pathname !== path) {
            history.push({
                ...getRoutePathWithParams(path),
            });
        }
        dispatch(
            setRoutePathForProxiesUnsavedChangesPopUp({
                path: path,
                selectOption: selectOption,
            })
        );
        // dispatch(setProxiesUnsavedChangesPopUp(true));
    } else if (
        window.location.pathname.includes('productGuide') &&
        settingUpdateInProgress
    ) {
         // if (path.includes('http')) {
        //     window.location.href = path;
        // } else if (window.location.pathname !== path) {
        //     history.push({
        //         ...getRoutePathWithParams(path),
        //     });
        // }
        navLinkSelectHandler(dispatch, setActiveNavLink, selectOption);
        if (path.includes('http')) {
            window.location.href = path;
        } else if (window.location.pathname !== path) {
            history.push({
                ...getRoutePathWithParams(path),
            });
        }
    
        // if (productGuideValue == false) {
        // } else {
        //     dispatch(setProductGuideUnsavedChangesPopUp(true));
        // }
        // if (
        //     products.lenght < 1 ||
        //     selectedBrands.length < 1 ||
        //     subCategoryRefineData.length < 1
        // ) {
        //     history.push(getRoutePathWithParams(path));
        // } else {
        //     dispatch(setProductGuideUnsavedChangesPopUp(true));
        // }
    } else if (
        window.location.pathname.includes('templates') &&
        settingUpdateInProgress
    ) {
        if (pageName === '') {
            if (path.includes('http')) {
                window.location.href = path;
            } else if (window.location.pathname !== path) {
                history.push({
                    ...getRoutePathWithParams(path),
                });
            }
        } else {
            dispatch(setTemplatesUnsavedChangesPopUp(true));
        }
        dispatch(
            setRoutePathForTemplatesUnsavedChangesPopUp({
                path: path,
                selectOption: selectOption,
            })
        );
    } else if (
        window.location.pathname.includes('settings') &&
        settingUpdateInProgress
    ) {
        if (settingsValue == false || productGuideValue == false) {
            localStorage.setItem('previousPath',history.location.state?.from);
            history.push(getRoutePathWithParams(path));
        } else {
            dispatch(setScheduleSurgeryUnsavedChangesPopUp(true));
        }
        dispatch(
            setRoutePathForSSUnsavedChangesPopUp({
                path: path,
                selectOption: selectOption,
            })
        );
    } else if (
        !isInReportUsageSubmitScreen &&
        window.location.pathname.includes('reportUsage')
    ) {
        dispatch(
            setShowUnsavedReportUsageChangesPopUp(true, path, selectOption)
        );
    } else if (
        !isCancelUsageSubmitted &&
        window.location.pathname.includes('nutrprocedure')
    ) {
        dispatch(
            setShowUnsavedReportUsageChangesPopUp(true, path, selectOption)
        );
    } else if (
        !isInReceiveSetSubmitScreen &&
        (window.location.pathname.includes('receiveSets') ||
            (employeeRole === FIM_USER_ROLE || employeeRole === FIA_USER_ROLE
                ? window.location.pathname === '/'
                : false))
    ) {
        dispatch(
            setRoutePathForReceiveSetUnsavedChangesPopUp({
                path: path,
                selectOption: selectOption,
            })
        );
        dispatch(setReceiveSetUnsavedChangesPopup(true));
    } else if (
        window.location.pathname.includes('consignmentAdd') &&
        consignmentAddCUInProgress
    ) {
        dispatch(
            setRoutePathForConsignmentAddUnsavedChangesPopUp({
                path: path,
                selectOption: selectOption,
            })
        );
        dispatch(setConsignmentAddUnsavedChangesPopUp(true));
    } else {
        navLinkSelectHandler(dispatch, setActiveNavLink, selectOption);
        if (path.includes('http')) {
            window.location.href = path;
        } else if (window.location.pathname !== path) {
            history.push({
                ...getRoutePathWithParams(path),
            });
        }
    }
};

export const getFormattedPhoneNumber = (
    numbersOnlyString,
    details,
    fromSettings = false
) => {
    const countryISOCode = localStorage.getItem('countryISOCode');

    if (countryISOCode !== US_COUNTRY_CODE && !fromSettings) {
        return numbersOnlyString;
    }
    if (!details && (!numbersOnlyString || isNaN(+numbersOnlyString))) {
        return;
    } else if (!numbersOnlyString && Number(numbersOnlyString)) {
        return;
    }

    const formattedFirstSixDigits =
        numbersOnlyString?.length > 3
            ? `(${numbersOnlyString.substring(
                0,
                3
            )}) ${numbersOnlyString.substring(3, 6)}`
            : numbersOnlyString;
    const formattedLastFourDigits =
        numbersOnlyString?.length > 6
            ? `-${numbersOnlyString.substring(6, 10)}`
            : '';

    const formattedPhoneNumberString = `${formattedFirstSixDigits}${formattedLastFourDigits}`;
    return formattedPhoneNumberString;
};

export const getHyphenFormattedNumber = (phoneNumber) => {
    if (!phoneNumber) return phoneNumber;

    const onlyDigits = phoneNumber.replace(/\D[^\.\(\)\-]/g, '');
    const formattedNumber =
        onlyDigits.slice(0, 3) +
        '-' +
        onlyDigits.slice(3, 6) +
        '-' +
        onlyDigits.slice(6);
    return formattedNumber;
};

export const getHyphenFormattedFaxNumber = (faxNumber) => {
    if (!faxNumber) return faxNumber;

    const onlyDigits = faxNumber.replace(/\D[^\.\(\)\-]/g, '');
    const formattedNumber =
        onlyDigits.slice(0, 1) +
        '-' +
        onlyDigits.slice(1, 4) +
        '-' +
        onlyDigits.slice(4, 7) +
        '-' +
        onlyDigits.slice(7);
    return formattedNumber;
};

export const fromOrderTypeToLabel = (currentOrderType, isMast = false) => {
    switch (currentOrderType) {
        case 'ZLC':
            return isMast ? 'MAST' : t('createOrderMethods.createSurgery');
        case 'ZLB':
            return t('orders.orderListFilterDropDown.usage.categoryName');
        case 'ZOR':
            return t('orders.orderListFilterDropDown.equity.categoryName');
        case 'ZKA':
            return t('createOrderMethods.createConsignmentReturn');
        // case 'ZKA':
        //     return 'Credits/Debits/Returns';
        case 'KB':
            return t('createOrderMethods.createConsigmentAdd');
        case 'KE':
            return t('createOrderMethods.createConsigmentBilling');
        case 'ZRE':
            return t('consignmentReturn.inventory.return');
        case 'L2':
            return t('consignmentReturn.inventory.return');
        case 'KR':
            return t('consignmentReturn.inventory.return');
        case 'G2':
            return t('consignmentReturn.inventory.return');
        default:
            return '';
    }
};

export const fromOrderTypeToModuleName = (
    currentOrderType,
    isMast = false,
    isUsageMast = false
) => {
    switch (currentOrderType) {
        case 'ZLC':
            return isMast ? 'MAST' : 'SCHEDULE_SURGERY';
        case 'ZLB':
            return isUsageMast
                ? 'REPORT_USAGE,MAST'
                : 'REPORT_USAGE,SCHEDULE_SURGERY';
        case 'ZOR':
            return 'EQUITY';
        case 'ZKA':
            return 'CONSIGNMENT_RETURN';
        case 'KB':
            return 'CONSIGNMENT_ADD';
        case 'KE':
            return 'CONSIGNMENT_BILLING';
        default:
            return '';
    }
};

export const fromLabelToOrderType = (label) => {
    switch (label) {
        case 'Surgery':
            return 'ZLC';
        case 'Usage':
            return 'ZLB';
        case 'EquityEquity':
            return 'ZOR';
        case 'Consignment Pickup':
            return 'ZKA';
        case 'Consignment Issues':
            return 'KL';
        case 'Consignment Billing':
            return 'KB';
        case 'Consignment Return':
            return 'ZKA';
        default:
            return '';
    }
};

export const checkScheduleSurgeryCUInProgress = (surgeryCUInProgress) => {
    return (
        (window.location.pathname.includes('scheduleSurgery') ||
            window.location.pathname.includes('modifySurgery')) &&
        surgeryCUInProgress
    );
};

export const handleScheduleSurgeryClick = (
    history,
    scheduleSurgeryWCMSLink
) => {
    if (process.env.ENABLE_SCHEDULE_SURGERY) {
        history.push(getRoutePathWithParams('/scheduleSurgery'));
    } else {
        window.location.href = scheduleSurgeryWCMSLink;
    }
};

export const logoutWithCleanUp = (msalInstance, dispatch, logoutHybrisAPI) => {
    window.onbeforeunload = null;
    localStorage.removeItem('lastSelDLPCalView');
    localStorage.removeItem('userAuthenticated');
    sessionStorage.removeItem('isCondensedViewState');
    sessionStorage.removeItem('employeeRole');
    localStorage.clear();
    sessionStorage.clear();
    process.env.ENABLE_SSO
        ? (dispatch(logoutSSO(true)), msalInstance.logoutRedirect())
        : dispatch(logoutHybrisAPI());
};

export const numberWithCommas = (x) => {
    // Input validation
    if (x === null || x === undefined || x === '') return '';
    
    // Convert to number if string
    const num = typeof x === 'string' ? parseFloat(x) : x;
    
    // Validate it's a number
    if (isNaN(num)) return x.toString();
    
    // Use Intl.NumberFormat for safe, locale-aware formatting
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2 // Preserve decimal places
    }).format(num);
};

export const setItemsDataHandler = (data, orderList) => {
    return {
        ...data,
        orderType: orderList?.currentOrderType
            ? orderList?.currentOrderType
            : null,
    };
};
export const capitalizeText = (string) => {
    return string.toLowerCase().replace(/(^|\s)\S/g, (l) => l.toUpperCase());
};

export const redirectToInitialPath = (history) => {
    const initialPath = history?.location?.state?.from
        ? history.location.state.from
        : null;
    const path = {
        state: null,
    };

    switch (initialPath) {
        case '/orders':
            return {
                ...getRoutePathWithParams(initialPath),
                ...path,
            };
        case '/orderHistory':
            return {
                ...getRoutePathWithParams(initialPath),
                ...path,
            };
        case '/home': 
            return {
                ...getRoutePathWithParams('/home'),
                ...path,
            };
        default:
            return {
                ...getRoutePathWithParams('/'),
                ...path,
            };
    }
};

export const validateUserRole = (loggedInUserRole) => {
    if (
        ALL_USER_ROLES.find((item) => item.role === loggedInUserRole)?.enabled
    ) {
        return true;
    }
    return false;
};

export const clearPersistStorage = () => {
    // Orders
    localStorage.removeItem('persist:orderFilterKey');
    localStorage.removeItem('persist:appliedOrderFilterKey');
    localStorage.removeItem('persist:pageVisibilityKey');
    localStorage.removeItem('persist:legacyMobileFilterReducerKey');
    localStorage.removeItem('persist:ordersListReducerKey');
    // Calendar
    localStorage.removeItem('persist:appliedCalendarFilterKey');
    // Surgery
    localStorage.removeItem('persist:surgeryKey');
    localStorage.removeItem('persist:surgeryProgressBarKey');
    localStorage.removeItem('persist:reportUsageProgressBarKey');
    localStorage.removeItem('persist:surgeryShippingMethodsKey');
    localStorage.removeItem('persist:surgeryShipToAddressKey');
    // Equity
    localStorage.removeItem('persist:equityProgressBarKey');
    localStorage.removeItem('persist:equityKey');
    localStorage.removeItem('persist:equityDetailsKey');
    localStorage.removeItem('persist:equityGetPricesForItemsKey');
    localStorage.removeItem('persist:equityShippingMethodsKey');
    localStorage.removeItem('persist:equityShipToAddressKey');
    localStorage.removeItem('persist:updateEquityKey');
    localStorage.removeItem('persist:equityValidateAccountKey');
    localStorage.removeItem('persist:impersonationUserKey');
    localStorage.removeItem('persist:surgerySubmissionKey');
    localStorage.removeItem('persist:updateSurgerySubmissionKey');
    // Report Usage or Report Payment
    localStorage.removeItem('persist:reportUsageReducer');
    // Usage Replenishment
    localStorage.removeItem('persist:reportUsageShipToAddressKey');
    localStorage.removeItem('persist:reportUsageShippingMethodsKey');
    localStorage.removeItem('persist:adminSearchResult');
};

export const SetTransform = createTransform(
    // transform state on its way to being serialized and persisted.
    (inboundState) => {
        // convert mySet to an Array.
        return {
            ...inboundState,
            mySet: [...inboundState.mySet],
        };
    },

    // transform state being rehydrated
    (outboundState) => {
        // convert mySet back to a Set.
        return {
            ...outboundState,
            mySet: new Set(outboundState.mySet),
        };
    }
);

export const detectDeviceInfo = () => {
    let userAgent = navigator.userAgent;
    let deviceName = '';
    let deviceType = '';
    let browser = '';
    const isIPadOSMasqueradingAsMac =
        userAgent.indexOf('Macintosh') !== -1 &&
        navigator.maxTouchPoints > 1 &&
        // Helps avoid misclassifying some touch-enabled Macs / other devices.
        /Safari/.test(userAgent) &&
        !/Chrome|CriOS|Edg|OPR|FxiOS/.test(userAgent);
    if (userAgent.indexOf('Windows') !== -1) {
        deviceName = 'Windows';
        deviceType = 'Desktop';
    } else if (
        isIPadOSMasqueradingAsMac
    ) {
        deviceName = 'iPad';
        deviceType = 'Tablet';
    } else if (userAgent.indexOf('Macintosh') !== -1) {
        deviceName = 'Mac';
        deviceType = 'Desktop';
    }else if (userAgent.indexOf('iPhone') !== -1) {
        deviceName = 'iPhone';
        deviceType = 'Phone';
    } else if (userAgent.indexOf('Android') !== -1) {
        deviceName = 'Android';
        deviceType = 'Phone';
    } else if (userAgent.indexOf('X11') !== -1) {
        deviceName = 'Linux';
        deviceType = 'Desktop';
    } else if (userAgent.indexOf('iPad') !== -1) {
        deviceName = 'iPad';
        deviceType = 'Tablet';
    } else {
        deviceName = 'Unkown';
        deviceType = 'Unkown';
    }
    if (userAgent.indexOf('Edge') !== -1 || userAgent.indexOf('Edg') !== -1) {
        browser = 'Edge';
    } else if (
        userAgent.indexOf('Opera') !== -1 ||
        userAgent.indexOf('OPR') !== -1 ||
        userAgent.indexOf('OPiOS') !== -1
    ) {
        browser = 'Opera';
    } else if (
        userAgent.indexOf('Firefox') !== -1 ||
        userAgent.indexOf('FxiOS') !== -1
    ) {
        browser = 'Firefox';
    } else if (userAgent.indexOf('UCBrowser') !== -1) {
        browser = 'UCBrowser';
    } else if (
        userAgent.indexOf('Chrome') !== -1 ||
        userAgent.indexOf('CriOS') !== -1
    ) {
        browser = 'Chrome';
    } else if (
        userAgent.indexOf('Safari') !== -1 &&
        (deviceName == 'iPhone' || deviceName == 'iPad' || deviceName == 'Mac')
    ) {
        browser = 'Safari';
    } else {
        browser = 'Unkown';
    }
    return { deviceName, deviceType, browser, userAgent };
};

export const getCurrentStep = (steps) => {
    let currentStep = '';
    Object.keys(steps).map((step) => {
        if (steps[step].current) currentStep = step;
    });

    return currentStep;
};

export const removePersistKey = (persistObj) => {
    const clonedObj = {
        ...persistObj,
    };
    delete clonedObj._persist;
    return clonedObj;
};

// export const hideScrolling = () => {
//     var x = window.scrollX;
//     var y = window.scrollY;
//     window.onscroll = function () {
//         window.scrollTo(x, y);
//     };
// };

// export const resumeScrolling = () => {
//     window.onscroll = function () {};
// #region "Disable/Enable scrolling"
const preventDefault = (e) => {
    e.preventDefault();
};
const preventDefaultForScrollKeys = (e) => {
    // left: 37, up: 38, right: 39, down: 40,
    // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
    const keys = {
        37: 0,
        38: 0,
        39: 0,
        40: 0,
        32: 0,
        33: 1,
        34: 1,
        35: 1,
        36: 1,
    };
    if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
    }
};
const supportsPassiveFunc = () => {
    // modern Chrome requires { passive: false } when adding event
    let supportsPassive = false;
    try {
        // create a throwaway element & event and (synchronously) test out our options
        window.addEventListener(
            'test',
            null,
            Object.defineProperty({}, 'passive', {
                get: function () {
                    supportsPassive = true;
                    return supportsPassive;
                },
            })
        );
    } catch (e) {
         logErrorToConsole(e);
    }
    const wheelOpt = supportsPassive
        ? {
            passive: false,
        }
        : false;
    const wheelEvent =
        'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
    return { wheelOpt, wheelEvent };
}; // call this to Disable
export const hideScrolling = () => {
    // alert('disable');
    const { wheelOpt, wheelEvent } = supportsPassiveFunc();
    window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);
    window.onscroll = function () {
        window.scrollTo(window.scrollX, window.scrollY);
    };
}; // call this to Enable
export const resumeScrolling = () => {
    // alert('enable');
    const { wheelOpt, wheelEvent } = supportsPassiveFunc();
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
    window.removeEventListener('touchmove', preventDefault, wheelOpt);
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
    window.onscroll = function () { };
};
// #endregion "end disable enable scrolling"

// #endregion  "end disable enable scrolling"
export const isMobileView = () => {
    return window.innerWidth <= sizes.mobileDevice;
};

export const getUrlparams = () => {
    return new URLSearchParams(window.location.search);
};
export const checkImpersonationActive = () => {
    return (
        sessionStorage.getItem('impersonatedUserId') !== 'null' &&
        sessionStorage.getItem('impersonationFlag') === 'true' &&
        getUrlparams().get('impersonatedFlag') === 'true'
    );
};

export const removeImperonatedUserDetail = () => {
    sessionStorage.removeItem('impersonationKey');
    sessionStorage.removeItem('impersonationFlag');

    sessionStorage.removeItem('impersonatedUserId');
    sessionStorage.removeItem('ProxyUser');

    localStorage.removeItem('ProxyUserRole');
    sessionStorage.removeItem('ProxyUserRole');
    sessionStorage.removeItem('ProxyimpersonationKey');
    sessionStorage.removeItem('ProxyDistrict');
};

export const removeProxyUserDetail = () => {
    sessionStorage.removeItem('ProxyimpersonationKey');
    sessionStorage.removeItem('ProxyDistrict');

    sessionStorage.removeItem('ProxyUser');

    localStorage.removeItem('ProxyUserRole');
};

// method for generating unique uuid
    export const generate_UUID = () => {
        // Modern browsers support crypto.randomUUID()
        if (crypto?.randomUUID) {
            return crypto.randomUUID();
        }
        
        // Fallback for older browsers
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    };

export const bundleRowToggleFunction = (e, key, expandRow) => {
    let rowToggle = {};
    const expandRowData = {
        ...expandRow,
    };
    const keyId = e[key];
    const checkKey = Object.keys(expandRowData).findIndex(
        (key) => key === keyId
    );

    if (checkKey >= 0) {
        const newToggle = Object.keys(expandRowData).reduce((object, key) => {
            if (key !== keyId) {
                object[key] = expandRowData[key];
            }
            return object;
        }, {});
        rowToggle = {
            ...newToggle,
        };
    } else {
        const newData = {
            [keyId]: true,
        };
        rowToggle = {
            ...newData,
            ...expandRowData,
        };
    }
    const validateBundle = e?.isBundleHeader ? e.isBundleHeader : false;
    return validateBundle ? rowToggle : expandRow;
};

export const bundleArrowFunction = (keyId, expandRow) => {
    const expandRowData = {
        ...expandRow,
    };
    const checkKey = Object.keys(expandRowData).findIndex(
        (key) => key === keyId
    );
    return checkKey >= 0 ? true : false;
};

export const preventBouncingEffect = () => {
    if (isMobileDevice()) {
        document.body.style.position = 'fixed';
        document.body.style.overflowY = 'hidden';
        document.body.style.width = '100%';
    }
};

export const revertBouncingEffect = () => {
    if (isMobileDevice()) {
        document.body.style.position = 'unset';
        document.body.style.overflowY = 'scroll';
        document.body.style.width = '100%';
    }
};

export const isSafari = () => {
    return (
        navigator.userAgent.search('Safari') >= 0 &&
        navigator.userAgent.search('Chrome') < 0
    );
};

export const isSmallIOSDevice = () => {
    // For iPhoneSE Safari Browser
    return (
        isSafari() &&
        isIOSiPhoneDevice() &&
        window.innerWidth <= 375 &&
        window.innerHeight <= 667 &&
        window.devicePixelRatio === 2
    );
};
//#region scroll top handler
/* if background has a height greater than viewport, opening or closing keyboards can make the background scroll.
this handler scrolls the background back to the top. 
use addScrollTopHandler while mounting. and removeScrollTopHandler while unmounting*/
const scrollTopHandler = () => {
    window.onscroll = function () {
        window.scrollTo(0, 0);
    };
};
export const addScrollTopHandler = () => {
    window.visualViewport.addEventListener('resize', scrollTopHandler);
    window.visualViewport.addEventListener('scroll', scrollTopHandler);
};

export const removeScrollTopHandler = () => {
    window.visualViewport.removeEventListener('resize', scrollTopHandler);
    window.visualViewport.removeEventListener('scroll', scrollTopHandler);
};

export const getRefTotalHeight = (ref, defaultMargin = 0) => {
    let height = ref.clientHeight;
    return height > 0 ? height + defaultMargin + 'px' : '0px';
};
export const isIpad = () => {
    if (
        (/\b(iPad)\b/.test(navigator.userAgent) &&
            /WebKit/.test(navigator.userAgent) &&
            !window.MSStream) ||
        (navigator.platform === 'MacIntel' &&
            navigator.maxTouchPoints &&
            navigator.maxTouchPoints === 5)
    ) {
        return true;
    }
    return false;
};

export const isLandscape = () => {
    const screen = window.screen;
    const orientation =
        (screen.orientation || {}).type ||
        screen.mozOrientation ||
        screen.msOrientation;
    if (
        orientation === 'landscape-primary' ||
        orientation === 'landscape-secondary' ||
        (orientation == undefined &&
            window.matchMedia('(orientation: landscape)').matches)
    ) {
        return true;
    }
    return false;
};

// #endregion scroll top handler

export const getRoutePathWithParams = (path) => {
    return { pathname: path, search: localStorage.getItem('urlSearchParams'), state: { from: window.location.pathname } };
};

export const getBannerHeight = (
    bannerHeader,
    announcementMargin,
    patchHeight = 0
) => {
    if (bannerHeader) {
        const bannerHeaderValue = bannerHeader.split('px')[0];
        const difference = Number(bannerHeaderValue) - 61 - patchHeight;
        const computedValue =
            difference > 61 ? difference + 'px' : announcementMargin;
        return computedValue;
    }
    return '';
};
// validation for multiple sets with same batch
export const sameBatchWithMultipleSetsValidation = (products) => {
    const clonedProducts = [...products];
    const validationObj = {};
    let sameBatchAllocationError = false;
    clonedProducts.forEach((product) => {
        if (
            validationObj[product.productCFN] &&
            validationObj[product.productCFN][
            product.batchId || product.reservationBatchId
            ]
        ) {
            validationObj[product.productCFN][
                product.batchId || product.reservationBatchId
            ] =
                validationObj[product.productCFN][
                product.batchId || product.reservationBatchId
                ] + 1;
        } else if (!validationObj[product.productCFN]) {
            validationObj[product.productCFN] = {};
            if (product.batchId || product.reservationBatchId)
                validationObj[product.productCFN][
                    product.batchId || product.reservationBatchId
                ] = 1;
        } else if (
            validationObj[product.productCFN] &&
            (product.batchId || product.reservationBatchId) &&
            !validationObj[product.productCFN][
            product.batchId || product.reservationBatchId
            ]
        ) {
            validationObj[product.productCFN][
                product.batchId || product.reservationBatchId
            ] = 1;
        }
    });

    clonedProducts.forEach((product) => {
        product.batchAllocationError = false;
        if (
            validationObj[product.productCFN] &&
            validationObj[product.productCFN][
            product.batchId || product.reservationBatchId
            ] > 1
        ) {
            product.batchAllocationError = true;
            sameBatchAllocationError = true;
        }
    });

    return { products: clonedProducts, sameBatchAllocationError };
};

export const updateNavBarPosition = (position, flag) => {
    const headerNavigator = document.getElementsByClassName('sideNav');

    if (headerNavigator && headerNavigator[0] && (flag ? true : !isMobileDevice())) {
        headerNavigator[0].style.position = position;
    }
};

export const updateDialogPosition = (position) => {
    const headerNavigator = document.getElementsByClassName('sideNav');
    const dialogWindowPosition =
        document.getElementsByClassName('ModalWebConatiner');
    if (dialogWindowPosition && dialogWindowPosition[0]) {
        headerNavigator[0].style.position = position;
    }
};

export const downloadFile = (base64Image, fileName) => {
    const link = document.createElement('a');
    link.href = base64Image;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
};
export const updateContainerPosition = (container, requiredPosition) => {
    const currentContainer = document.querySelector(container);
    if (currentContainer) {
        currentContainer.style.position = requiredPosition;
    }
};

export const itemsWithSamePoNumberAndImage = (items) => {
    const poNumber = items[0]?.payment?.poNumber;
    const poAttachment = items[0]?.payment?.poAttachment;
    let isAllItemsHaveSameImages = false;
    let isAllItemsHaveSamePoNumber = false;
    if (poNumber) {
        isAllItemsHaveSamePoNumber = items.every(
            (item) => item?.payment?.poNumber === poNumber
        );
        isAllItemsHaveSameImages = items.every(
            (item) => item?.payment?.poAttachment === poAttachment
        );
    }

    return { isAllItemsHaveSameImages, isAllItemsHaveSamePoNumber };
};

export const checkPoFileExtension = (fileName) => {
    let parts = fileName.split('.');
    const type = parts[parts.length - 1];
    switch (type.toLowerCase()) {
        case 'jpg':
        case 'jpeg':
        case 'gif':
        case 'tif':
        case 'tiff':
        case 'pdf':
        case 'bmp':
        case 'msg':
        case 'doc':
        case 'docx':
        case 'xls':
        case 'txt':
        case 'html':
        case 'png':
            // etc
            return true;
    }
    return false;
};

export const checkFileExtension = (fileName) => {
    let parts = fileName.split('.');
    const type = parts[parts.length - 1];
    switch (type.toLowerCase()) {
        case 'jpg':
        case 'jpeg':
        case 'gif':
        case 'tif':
        case 'tiff':
        case 'pdf':
        case 'bmp':
        case 'msg':
        case 'doc':
        case 'docx':
        case 'xls':
        case 'txt':
        case 'html':
        case 'png':
        case 'heic':
            // etc
            return true;
    }
    return false;
};

export const setDynatracePageName = (pageName) => {
    localStorage.setItem('pageName', pageName);
};

export const isUsageSubmissionProcessing = (orderStatus) =>
    orderStatus?.statusDescription === 'Records Found' &&
    typeof orderStatus?.status === 'string' &&
    !orderStatus.status.includes('Exception') &&
    (orderStatus.status.includes('Usage Order Submitted Successfully') ||
        orderStatus.status.toLowerCase().includes('process'));

export const getOrderLockedAction = (ctaID, orderType, orderStatus) => {
    // REPORT_USAGE = "ReportUsage";
    // DRAFT_USAGE_EDIT = "DraftUsageEdit";
    // NO_USAGE_TO_REPORT = "NoUsageToReport";
    // DRAFT_SURGERY_EDIT = "DraftSurgeryEdit";
    // DRAFT_EQUITY_EDIT = "DraftEquityEdit";
    // REPORT_PAYMENT = "ReportPayment";
    // MOBILE_REPORT_PAYMENT = "MobileReportPayment";
    // SUBMITTED_SURGERY_EDIT = "SubmittedSurgeryEdit";

    if (ctaID === CTA_IDS.editOrder && orderType === 'ZLC') {
        if (orderStatus === t('orders.orderStatuses.draftNotSubmitted'))
            return 'DraftSurgeryEdit';
        else return 'SubmittedSurgeryEdit';
    } else if (ctaID === CTA_IDS.editOrder && orderType === 'ZOR')
        return 'DraftEquityEdit';
    else if (ctaID === CTA_IDS.reportUsage) return 'ReportUsage';
    else if (orderType === 'ZLB') {
        if (ctaID === CTA_IDS.editOrder) return 'DraftUsageEdit';
        else if (ctaID === CTA_IDS.reportPayment) return 'ReportPayment';
    } else if (ctaID === CTA_IDS.noUsageToReport) return 'NoUsageToReport';
    else if (ctaID === CTA_IDS.unidPostponed) return 'UnidPostPoned';
    else return '';
};

export const isTransferSurgery = () => {
    return (
        window.location.hash.includes('transferSurgery') ||
        window.location.pathname.includes('transferSurgery')
    );
};
export const isModifySurgery = () => {
    return (
        window.location.hash.includes('modifySurgery') ||
        window.location.pathname.includes('modifySurgery')
    );
};

export const isModifyEquity = () => {
    return (
        window.location.hash.includes('modifyEquity') ||
        window.location.pathname.includes('modifyEquity')
    );
};

export const isDXPOrder = (vendorCaseID) => {
    return vendorCaseID && vendorCaseID.startsWith('MT_');
};

export const isUNiDOrder = (vendorCaseID) => {
    return vendorCaseID && vendorCaseID.startsWith('UH_');
};

export const cumulativeLimitAndThresholdLimitQuantityCalculation = (
    existingProducts
) => {
    let existingCumulativeLimitPHValuesWithQuantity = {};
    let existingItemsWithQuantity = {};
    existingProducts.forEach((exiProduct) => {
        if (exiProduct.cumulativeLimitPHValue) {
            existingCumulativeLimitPHValuesWithQuantity[
                exiProduct.cumulativeLimitPHValue
            ] = {
                quantity: existingCumulativeLimitPHValuesWithQuantity[
                    exiProduct.cumulativeLimitPHValue
                ]?.quantity
                    ? existingCumulativeLimitPHValuesWithQuantity[
                        exiProduct.cumulativeLimitPHValue
                    ].quantity + exiProduct.quantity
                    : exiProduct.quantity,
            };
        }
        if (exiProduct.thresholdLimit) {
            if (exiProduct.productCFN in existingItemsWithQuantity) {
                existingItemsWithQuantity[exiProduct.productCFN].quantity =
                    existingItemsWithQuantity[exiProduct.productCFN].quantity +
                    exiProduct.quantity;
            } else {
                existingItemsWithQuantity[exiProduct.productCFN] = {
                    quantity: exiProduct.quantity,
                };
            }
        }
    });

    return {
        existingItemsWithQuantity,
        existingCumulativeLimitPHValuesWithQuantity,
    };
};
export const cumulativeLimitAndThresholdLimitQuantityCalculationSets = (
    existingProducts
) => {
    let existingCumulativeLimitPHValuesWithQuantity = {};
    let existingItemsWithQuantity = {};
    existingProducts.forEach((exiProduct) => {
        if (exiProduct.thresholdLimit && exiProduct.cumulativeLimit) {
            if (existingItemsWithQuantity[exiProduct.productCFN]) {
                existingItemsWithQuantity[exiProduct.productCFN].quantity =
                    existingItemsWithQuantity[exiProduct.productCFN].quantity +
                    exiProduct.quantity;
            } else {
                existingItemsWithQuantity[exiProduct.productCFN] = {
                    quantity: exiProduct.quantity,
                };
            }
        }
        if (exiProduct.thresholdLimit && !exiProduct.cumulativeLimit) {
            if (existingItemsWithQuantity[exiProduct.productCFN]) {
                existingItemsWithQuantity[exiProduct.productCFN].quantity =
                    existingItemsWithQuantity[exiProduct.productCFN].quantity +
                    exiProduct.quantity;
            } else {
                existingItemsWithQuantity[exiProduct.productCFN] = {
                    quantity: exiProduct.quantity,
                };
            }
        }
    });
    return {
        existingItemsWithQuantity,
        existingCumulativeLimitPHValuesWithQuantity,
    };
};

export const cumThresLimitErrProdsCalc = (validatedProducts) => {
    const cumulativeErrorProducts = [];
    const productsNotAddedToCartCumulativeOrThresholdLimitError =
        validatedProducts.filter(
            (product) =>
                (product.cumulativeLimitError || product.thresholdLimitError) &&
                product.cumulativeLimitPHValue
        );
    // filtering products with samePh values

    productsNotAddedToCartCumulativeOrThresholdLimitError.forEach((item) => {
        const productIndex = cumulativeErrorProducts.findIndex(
            (product) =>
                product.cumulativeLimitPHValue === item.cumulativeLimitPHValue
        );
        if (productIndex === -1) {
            cumulativeErrorProducts.push(item);
        }
    });

    return cumulativeErrorProducts;
};

export const cumThresLimitErrProdsCalcSurgery = (validatedProducts) => {
    const cumulativeErrorProducts = {};
    const productsNotAddedToCartCumulativeOrThresholdLimitError =
        validatedProducts.filter(
            (product) =>
                (product.cumulativeLimitError || product.thresholdLimitError) &&
                product.cumulativeLimitPHValue
        );
    // filtering products with samePh values

    productsNotAddedToCartCumulativeOrThresholdLimitError.forEach((item) => {
        if (item.cumulativeLimitPHValue in cumulativeErrorProducts) {
            cumulativeErrorProducts[item.cumulativeLimitPHValue] = [
                ...cumulativeErrorProducts[item.cumulativeLimitPHValue],
                item,
            ];
        } else {
            cumulativeErrorProducts[item.cumulativeLimitPHValue] = [item];
        }
    });
    return cumulativeErrorProducts;
};
export const clearStorageBrowserClose = (dispatch) => {
    const isScheduleSurgeryFlow =
        window.location.pathname.includes('scheduleSurgery') ||
        window.location.pathname.includes('modifySurgery');

    if (!isScheduleSurgeryFlow) {
        dispatch(resetSurgeryDetails());
        dispatch(reSetProgressBarStatus());
        dispatch(resetCreateOrUpdateSurgery());
    }
    dispatch(resetReportUsageStates());
};
export const hasWhiteSpace = (s) => {
    return /\s/g.test(s);
};

export const clearDataOnNewImpersonate = (dispatch) => {
    dispatch(resetAppliedOrderListFilter());
    dispatch(resetOrderListFilter());
    dispatch(resetCalendarSelectedDate());
    dispatch(resetAwaitingToggle());
    dispatch(resetAwaitingToggleMobile());
    dispatch(resetAccountFilterState());
    dispatch(resetPhysicianFilterState());
};

let _accountFilterSnapshot = null;

export const saveAccountFilterStateForImpersonation = (state) => {
    try {
        const acc = state?.accountReducer || {};
        _accountFilterSnapshot = {
            accountFilterSnapshot: acc.accountFilterSnapshot ?? null,
            selectedAccountFilters: acc.selectedAccountFilters ?? {},
            filterParams: acc.filterParams ?? {},
            accountFilterParamValues: acc.accountFilterParamValues ?? '',
            // filtervalues is the live state field set by setFilterAppliedView
            filtervalues: acc.filtervalues ?? [],
            appliedView: acc.appliedView ?? {
                appliedDistrict: {},
                appliedTerritory: {},
                appliedAccount: {},
            },
            appliedFilter: acc.appliedFilter ?? {},
        };
    } catch (e) {
        logErrorToConsole(e);
    }
};

export const restoreAccountFilterStateAfterImpersonation = (dispatch) => {
    if (!_accountFilterSnapshot) return;
    dispatch(restoreAccountFilterState(_accountFilterSnapshot));
    _accountFilterSnapshot = null;
};

let _physicianFilterSnapshot = null;

export const savePhysicianFilterStateForImpersonation = (state) => {
    try {
        const acc = state?.accountReducer || {};
        _physicianFilterSnapshot = {
            physicianFilterSnapshot: acc.physicianFilterSnapshot ?? null,
            selectedPhysicianFilters: acc.selectedPhysicianFilters ?? {},
            physicianFilterParamValues: acc.physicianFilterParamValues ?? '',
            physicianFiltervalues: acc.physicianFiltervalues ?? [],
            appliedViewPhy: acc.appliedViewPhy ?? {
                appliedDistrict: {},
                appliedTerritory: {},
                appliedAccount: {},
            },
            appliedFilterPhy: acc.appliedFilterPhy ?? {},
            viewValuesPhysician: acc.viewValuesPhysician ?? [],
            checkboxValues: acc.checkboxValues ?? [],
            getPhysicianFilter: acc.getPhysicianFilter ?? false,
        };
    } catch (e) {
        logErrorToConsole(e);
    }
};

export const restorePhysicianFilterStateAfterImpersonation = (dispatch) => {
    if (!_physicianFilterSnapshot) return;
    dispatch(restorePhysicianFilterState(_physicianFilterSnapshot));
    _physicianFilterSnapshot = null;
};

let _orderFilterSnapshot = null;
const ORDERS_SNAPSHOT_SESSION_KEY = 'ordersFilterSnapshotBeforeImpersonation';

/**
 * Saves CC user's current Orders filter state before impersonation starts.
 * Uses dual-layer storage: in-memory (fast) + sessionStorage (survives refresh).
 * Called in both admin proxy (impersonateProxy) and self-proxy (initiateProxy) flows.
 *
 * Pattern:
 * 1. On impersonation start → call saveOrderFilterStateForImpersonation(store.getState())
 * 2. CC user enters impersonated user's Orders page; impersonated Orders state replaces snapshot
 * 3. On impersonation end → call restoreOrderFilterStateAfterImpersonation(dispatch)
 * 4. Dispatch single RESTORE_ORDER_FILTER_SNAPSHOT action (atomic restore, single re-render)
 */
export const saveOrderFilterStateForImpersonation = (state) => {
    try {
        const orders = state?.orderFilterReducer || {};
        const appliedOrders = state?.appliedOrdersFilterReducer || {};

        const snapshot = {
            appliedCategory: orders.appliedCategory
                ? { ...orders.appliedCategory }
                : {},
            appliedQuickFilter: orders.appliedQuickFilter
                ? { ...orders.appliedQuickFilter }
                : {},
            appliedFilter: orders.appliedFilter ? { ...orders.appliedFilter } : {},
            appliedView: orders.appliedView ? { ...orders.appliedView } : {},
            filter: appliedOrders.filter ? { ...appliedOrders.filter } : {},
            pageNo: appliedOrders.pageNo,
            sortOrder: appliedOrders.sortOrder,
            sortParam: appliedOrders.sortParam,
        };

        _orderFilterSnapshot = snapshot;
        sessionStorage.setItem(ORDERS_SNAPSHOT_SESSION_KEY, JSON.stringify(snapshot));
    } catch (e) {
        logErrorToConsole(e);
    }
};

export const restoreOrderFilterStateAfterImpersonation = (dispatch) => {
    try {
        let snapshot = null;

        // Priority 1: Fast in-memory cache
        if (_orderFilterSnapshot) {
            snapshot = _orderFilterSnapshot;
        } else {
            // Priority 2: SessionStorage fallback (survives refresh)
            try {
                const stored = sessionStorage.getItem(ORDERS_SNAPSHOT_SESSION_KEY);
                if (stored) {
                    snapshot = JSON.parse(stored);
                }
            } catch (parseError) {
                logErrorToConsole(parseError);
            }
        }

        if (!snapshot) {
            // No snapshot available; clear state and reset filters
            dispatch(resetAppliedOrderListFilter());
            dispatch(resetOrderListFilter());
        } else {
            // Atomic restore: single dispatch updates both orderFilterReducer and appliedOrdersFilterReducer
            // Significantly reduces re-renders vs. 6 sequential dispatches
            dispatch(restoreOrderFilterSnapshot(snapshot));
        }
    } catch (e) {
        logErrorToConsole(e);
        dispatch(resetAppliedOrderListFilter());
        dispatch(resetOrderListFilter());
    } finally {
        _clearOrderFilterSnapshot();
    }
};

const _clearOrderFilterSnapshot = () => {
    _orderFilterSnapshot = null;
    try {
        sessionStorage.removeItem(ORDERS_SNAPSHOT_SESSION_KEY);
    } catch (e) {
        logErrorToConsole(e);
    }
    // Clear persisted Orders filter state to prevent stale rehydration on next page load.
    // Both reducers use redux-persist: orderFilterReducer (persist:orderFilterKey) and
    // appliedOrdersFilterReducer (persist:appliedOrderFilterKey).
    try {
        localStorage.removeItem('persist:orderFilterKey');
        localStorage.removeItem('persist:appliedOrderFilterKey');
    } catch (e) {
        logErrorToConsole(e);
    }
};

export const getSectionStatus = (data, section) => {
    return data[Object.keys(data)[section]].done;
};

export const checkProxyActive = () => {
    return (
        // sessionStorage.getItem('impersonatedUserId') !== 'null' &&
        sessionStorage.getItem('ProxyimpersonationKey') &&
        getUrlparams().get('proxyFlag') === 'true'
    );
};

export const checkRequestInvoice = (callToAction) => {
    const isRequestInvoiceActive =
        callToAction?.length > 0
            ? callToAction.filter((x) => x.ctaId === CTA_IDS.requestInvoice)
            : [];
    return isRequestInvoiceActive.length > 0 ? true : false;
};

export const checkTemplateReviewUserRoleChanges = (
    employeeRole,
    surgeryObjectField
) => {
    return surgeryObjectField.find((item) => item.role === employeeRole);
};

export const updateIsAllDistrictId = (districtId) => {
    return districtId === ALLDISTRICTS ? '' : districtId;
};

export const updateIsAllTerritoryId = (territoryId) => {
    return territoryId === ALLTERRITORIES ? '' : territoryId;
};
export const getUserDetails = () => {
    if (checkImpersonationActive() || checkProxyActive()) {
        return sessionStorage.getItem('ProxyUserRole');
    } else {
        return sessionStorage.getItem('employeeRole');
    }
};

// need to remove this bypass logic once it is added to backend logic
const BYPASS_BACKEND_CHECK_ROUTES = ['fieldInventoryDashboard'];

export const isCorrectURL = (routes, path, accessibleURL, obj) => {   
    // need to remove this bypass logic once it is added to backend logic
    const pathSegment = path.split('/')[1];
    if (BYPASS_BACKEND_CHECK_ROUTES.includes(pathSegment)) return null;
    // Treat orderHistory the same as orders for access control (uses same API/permissions)
    const accessCheckSegment = pathSegment === 'orderHistory' ? 'orders' : pathSegment;
    return routes.filter(
        (route) => route.path.split('/')[1] == pathSegment
    ).length
        ? accessibleURL.some((item) =>
            item == accessCheckSegment
                ? obj[item] === undefined
                    ? true
                    : obj[item]
                : false
        )
            ? null
            : ERRORDETAILS()[1]
        : ERRORDETAILS()[0];
};

// eslint-disable-next-line no-unused-vars
export const forbiddenErrorCheck = (instance, dispatch, logoutAPI) => {
    if (
        sessionStorage.getItem('employeeRole') &&
        sessionStorage.getItem('employeeRole') != 'undefined'
    ) {
        const path = window.location.pathname;
        // need to remove this bypass logic once it is added to backend logicrestr
        if (BYPASS_BACKEND_CHECK_ROUTES.includes(path.split('/')[1])) return false;
        if (
            EQUITY_USER_PAGE_VISIBILITY_RULE.filter(
                (item) => item.role == getUserDetails()
            ).length > 0
        ) {
            const accessibleURL = EQUITY_USER_PAGE_VISIBILITY_RULE.filter(
                (item) => item.role == getUserDetails()
            )[0].urlAccess;
            const currentSegment = path.split('/')[1];
            // Treat orderHistory the same as orders for access control
            const checkSegment = currentSegment === 'orderHistory' ? 'orders' : currentSegment;
            const errorCheck = routes.filter(
                (route) => route.path.split('/')[1] == currentSegment
            ).length
                ? accessibleURL.some((item) => item == checkSegment)
                    ? null
                    : ERRORDETAILS()[1]
                : ERRORDETAILS()[0];
            return errorCheck ? true : false;
        }
    } else {
        return false;
    }
};

export const numFormatObj = {
    style: 'currency',
    currency: localStorage.getItem('currencyISOCode'),
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
};

// Get the standard decimal digits for a currency (e.g., JPY=0, USD=2, KWD=3)
export const getCurrencyDecimalDigits = (currencyCode) => {
    try {
        const formatter = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: currencyCode,
        });
        return formatter.resolvedOptions().minimumFractionDigits;
    } catch (error) {
        console.error('Error getting currency decimal digits:', error);
        return 2; // Default fallback
    }
};

export const updateCurrencyCode = (currenyISOCode) => {
    const storedCode = localStorage.getItem('currencyISOCode');
    const currency = currenyISOCode || (storedCode && storedCode !== 'undefined' ? storedCode : null) || 'USD';
    const decimalDigits = getCurrencyDecimalDigits(currency);
    
    // Update all currency format objects
    numFormatObj.currency = currency;
    numFormatObj.minimumFractionDigits = decimalDigits;
    numFormatObj.maximumFractionDigits = decimalDigits;
    
    consignmentBillingNumFormatObj.currency = currency;
    consignmentBillingNumFormatObj.minimumFractionDigits = decimalDigits;
    consignmentBillingNumFormatObj.maximumFractionDigits = decimalDigits;
    
    consignmentReturnNumFormatObj.currency = currency;
    consignmentReturnNumFormatObj.minimumFractionDigits = decimalDigits;
    consignmentReturnNumFormatObj.maximumFractionDigits = decimalDigits;
    
    equityNumFormatObj.currency = currency;
    equityNumFormatObj.minimumFractionDigits = decimalDigits;
    equityNumFormatObj.maximumFractionDigits = decimalDigits;
    
    equityPriceFormatObj.currency = currency;
    equityPriceFormatObj.minimumFractionDigits = decimalDigits;
    equityPriceFormatObj.maximumFractionDigits = decimalDigits;
    
    reportUsagePriceFormatObj.currency = currency;
    reportUsagePriceFormatObj.minimumFractionDigits = decimalDigits;
    reportUsagePriceFormatObj.maximumFractionDigits = decimalDigits;
    
    consignmentBillingPriceFormatObj.currency = currency;
    consignmentBillingPriceFormatObj.minimumFractionDigits = decimalDigits;
    consignmentBillingPriceFormatObj.maximumFractionDigits = decimalDigits;
};


export const getCurrencySymbol = (currencyISOCode) => {
    try {
        // Use Intl.NumberFormat to get the currency symbol
        const symbol = new Intl.NumberFormat('en', {
            style: 'currency',
            currency: currencyISOCode,
            currencyDisplay: 'symbol',
        })
            .formatToParts(0)
            .find((part) => part.type === 'currency').value;

        return symbol;
    } catch (error) {
        console.error('Error getting currency symbol:', error);
        return '$'; // Default fallback
    }
};
export const setCurrencyFormat = (
    amount,
    changeFormat = false,
    format = {}
) => {
    const locale = localStorage.getItem('languageISOCode');
    if (!amount) amount = 0;

    return getPriceInNumberDataType(amount).toLocaleString(
        locale && locale != 'undefined' ? locale : 'en-US',
        numFormatObj.currency && numFormatObj.currency !== 'undefined'
            ? changeFormat && format.currency
                ? {
                    ...numFormatObj,
                    ...format,
                }
                : numFormatObj
            : {
                minimumFractionDigits: numFormatObj.minimumFractionDigits ?? 2,
                maximumFractionDigits: numFormatObj.maximumFractionDigits ?? 2,
            }
    );
};

export const setCurrencyFormatWithoutSymbol = (amount) => {
    const locale = localStorage.getItem('languageISOCode');
    if (!amount) amount = 0;

    return getPriceInNumberDataType(amount).toLocaleString(
        locale && locale != 'undefined' ? locale : 'en-US',
        {
            minimumFractionDigits: numFormatObj.minimumFractionDigits ?? 2,
            maximumFractionDigits: numFormatObj.maximumFractionDigits ?? 2,
        }
    );
};

export const checkPriceOverRideOrderAmount = (priceDetails) => {
    let isPriceOverrideApplicable = false;
    if (priceDetails?.length > 0) {
        const checkPriceOverride = priceDetails.filter((x) => x?.value);
        isPriceOverrideApplicable =
            checkPriceOverride?.length > 0 ? true : false;
        return isPriceOverrideApplicable;
    }
    return isPriceOverrideApplicable;
};

export const vendorCaseIdMsgTemplate = (description, statusCode) => {
    const vendorCaseIdDetails = {
        templateMsg: '',
        linkedSstRef: '',
    };
    const splitDescription = description.split(',');
    const sstRef =
        splitDescription?.length > 0
            ? splitDescription.splice(splitDescription.length - 1, 1).join('')
            : '';
    const caseId =
        splitDescription?.length > 0 ? splitDescription.join(',') : '';
    if (statusCode === '11908') {
        vendorCaseIdDetails.templateMsg = `Case ${caseId} used on order ${sstRef}. Click here to discard the current order and view `;
    } else if (statusCode === '11909') {
        vendorCaseIdDetails.templateMsg = `Non Use Submitted for Unid surgery Order ${sstRef} with Case Id : ${caseId}. Click here to discard the current order and view `;
    }
    vendorCaseIdDetails.linkedSstRef = sstRef;
    return vendorCaseIdDetails;
};

export const limitQuantityTo50 = (quantity) => {
    return parseInt(quantity) > 50 ? 50 : parseInt(quantity);
};

export const format = (salesForce) => {
    return `(${salesForce})`;
};

export const territoryValue = (data) => {
    const territory = data
        ?.map((m) =>
            [
                m?.territoryName && m?.territoryName,
                m?.territory && m?.territory,
                m?.salesForce && format(m?.salesForce),
            ].join(' ')
        )
        .join(', ');
    return territory;
};

export const currencySymbol = (data) => {
    const regex = /\p{Sc}/gu; // Regular expression to match any currency symbol
    let match;
    while ((match = regex.exec(data)) !== null) {
        return match[0];
    }
};

// This function will return currency symbol and remove amount part. (20$->$)
export const countryCurrencySymbol = (currency) => {
    const match = currency.match(/[^\d.,\s]+/);

    if (match) {
        return match[0];
    }
    return '$';
};

// Removing the Prefix AH_ and UH_ from vendorCaseID;
export const removePrefixFromUnidCaseId = (unidCaseId) => {
    if (unidCaseId.startsWith('AH_')) {
        return unidCaseId.slice(3);
    } else if (unidCaseId.startsWith('UH_')) {
        return unidCaseId.slice(3);
    } else return unidCaseId;
};

// This will return the Vendor Hub name
export const getHubName = (unidCaseId) => {
    if (unidCaseId.startsWith('AH_')) {
        return 'Aible';
    } else if (unidCaseId.startsWith('UH_')) {
        return 'UNiD';
    }
};

export const checkNonTissueExtraItems = (
    removeExtraItem = {},
    products,
    forEach = false
) => {
    if (
        removeExtraItem[forEach ? products.salesOrg : products[0].salesOrg] ===
        'VISIBLE' &&
        (forEach ? !products.isSet : !products[0].isSet)
    ) {
        return true;
    } else return false;
};

export const displayDeniedOverride = (role, countryISOCode) => {
    if (
        role === SR_USER_ROLE ||
        role === CS_USER_ROLE ||
        role === CSR_USER_ROLE ||
        role === DM_USER_ROLE ||
        role === SM_USER_ROLE
    ) {
        if (countryISOCode === 'US') {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
    // export const rearrangeItems = (orderArray) => {
    //     return orderArray.sort((a, b) => b.barcodeCounitemsWithBarcode.forEach((item) => delete item.barcodeCount);t - a.barcodeCount);
};
export const rearrangeItems = (items, orderArray) => {
    const barcodeSet = new Set(orderArray.map((item) => item.barCodeNumber)); // Create a set of barcode numbers from array B

    const itemsInB = [];
    const remainingItemsInA = [];

    items.forEach((item) => {
        if (barcodeSet.has(item.barcode)) {
            itemsInB.push(item);
        } else {
            remainingItemsInA.push(item);
        }
    });

    const sortedItemsInB = orderArray.reduce((acc, item) => {
        const foundItem = itemsInB.find(
            (aItem) => aItem.barcode === item.barCodeNumber
        );
        if (foundItem) {
            acc.push(foundItem);
        }
        return acc;
    }, []);

    // Keep the original order of items in remainingItemsInA
    const result = remainingItemsInA.concat(sortedItemsInB);

    return result;
};

export const modifyObject = (obj) => {
    const poNumberLength = obj[0]?.payment?.poNumber?.length ?? 0;

    // Loop through keys and remove elements based on poNumber length
    for (let i = 0; i < poNumberLength; i++) {
        delete obj[0][i.toString()];
    }

    return obj;
};

export const checkProductBomDetailsExtracter = (
    array,
    isFromMoreTemplate = false,
) => {
    if (!Array.isArray(array)) {
        return {
            orderType: isFromMoreTemplate ? '' : 'ZLC',
            salesOrg: '',
            productCFN: '',
        };
    }  
      const filteredData = array.filter((item) => item.isSet);

    // Collect unique salesOrg and productCFN in a single iteration
    const salesOrgsSet = new Set();
    const productCFNs = [];

    filteredData.forEach((item) => {
        if (item.salesOrg) salesOrgsSet.add(item.salesOrg);
        productCFNs.push(item.productCFN || item.cfn);
    });

    const details = {
        orderType: isFromMoreTemplate ? '' : 'ZLC',
        salesOrg: [...salesOrgsSet].join(',') || '',
        productCFN: productCFNs.join(','),
    };

    return details;
};

//setUp initial procedure data for japan user(to hide and display)
//procedureFilterData is written for both NOT_VISIBLE and ENABLED API condition.
export const procedureFilterData = (constItem, data, flag, ...rest) => {
    const lowerCaseArray = data?.metadata?.map((item) =>
        item.toLowerCase().trim()
    );
    const trimData = data?.metadata?.map((item) => item.trim());
    const visibility = data.ruleValue;
    // const adv = ['aquamantys', 'plasmablade x'];
    let advance = false;

    //for incaseSensitive comparision
    const pattern = trimData;
    // ? new RegExp(`^(${trimData.join('|')})$`, 'i')
    // : '';

    if (rest[0] === 'biologicsUsed') {
        if (!flag) {
            if (visibility === 'NOT_VISIBLE') {
                return constItem
                    .map((item, index) => {
                        return {
                            code: item.code,
                            description: item?.description,
                            extraDescription: item?.extraDescription,
                            isSelected: null,
                        };
                    })
                    .filter(
                        (item) =>
                            !lowerCaseArray.includes(
                                item.description.toLowerCase()
                            )
                    );
            } else {
                return constItem
                    .map((item, index) => {
                        // Split the item using '@'
                        // const [description, extraDescription] = item.name
                        //     .split('@')
                        //     .map((part) => part.trim());

                        return {
                            code: item.code,
                            description: item?.description,
                            extraDescription: item?.extraDescription,
                            isSelected: null,
                        };
                    })
                    .filter((item) => pattern.test(item.description));
            }
        } else {
            if (flag === 'Procedure_Data_Enabled') {
                // const array = constItem.map((item, index) => {
                //     // Split the item using '@'
                //     // const [description] = item.description
                //     //     .split('@')
                //     //     .map((part) => part.trim());

                //     return {
                //         code: item.code,
                //         description: item?.description,
                //         extraDescription: item?.extraDescription,
                //         isSelected: null,
                //     };
                // });
                return ['ADDITIONAL_PROCEDURE_DATA'];
            } else {
                return [flag];
            }
        }
    } else if (constItem) {
        let array;
        if (!flag) {
            if (visibility === 'VISIBLE') {
                array = constItem
                    .filter((item) =>
                        lowerCaseArray.includes(item.code.toLowerCase())
                    )
                    .map((item, index) => {
                        let obj = {
                            code: item.code,
                            description: item.description,
                            isSelected: null,
                        };
                        if (item.description === 'Advanced Energy') {
                            const advanceEnergy = getAdvanceEnergy(
                                item.description,
                                rest[0]
                            );
                            if (advanceEnergy === 'disable') {
                                obj.advancedEnergyProduct = null;
                                advance = true;
                            } else if (advanceEnergy) {
                                obj.advancedEnergyProduct = advanceEnergy;
                            } else {
                                obj.advancedEnergyProduct = null;
                                advance = true;
                            }
                        }
                        if (item.description == 'MazorX Robot Used') {
                            obj.mazorKitCode = '';
                        }
                        return obj;
                    });
            } else {
                array = constItem
                    .filter((item) => pattern.test(item.description))
                    .map((item, index) => {
                        let obj = {
                            code: item.code,
                            description: item.description,
                            isSelected: null,
                        };
                        if (item.description === 'Advanced Energy') {
                            const advanceEnergy = getAdvanceEnergy(
                                item.description,
                                rest[0]
                            );
                            if (advanceEnergy === 'disable') {
                                obj.advancedEnergyProduct = null;
                                advance = true;
                            } else if (advanceEnergy) {
                                obj.advancedEnergyProduct = advanceEnergy;
                            } else {
                                obj.advancedEnergyProduct = null;
                                advance = true;
                            }
                        }
                        if (item.description == 'MazorX Robot Used') {
                            obj.mazorKitCode = '';
                        }
                        return obj;
                    });
            }
            if (advance) {
                array = array.filter(
                    (item) => item.advancedEnergyProduct !== null
                );
            }
            // else if (trimData && array.length < 1) {
            //     array = ADDITIONAL_PROCEDURE_DATA;
            // }
            return array;
        } else if (flag === 'Procedure_Data_Enabled') {
            array = constItem
                .filter((item) => {
                    if (item.description === 'Advanced Energy') {
                        const advanceEnergy = getAdvanceEnergy(
                            item.description,
                            rest[0]
                        );
                        return advanceEnergy !== 'disable';
                    }
                   
                    return true;
                })
                .map((item) => {
                    if (item.description === 'Advanced Energy') {
                        const advanceEnergy = getAdvanceEnergy(
                            item.description,
                            rest[0]
                        );

                        return {
                            ...item,
                            advancedEnergyProduct: advanceEnergy || null,
                        };
                    }
                    return item;
                });

            return array;
        } else {
            return ['ADDITIONAL_PROCEDURE_DATA'];
        }
    }
};

export const getAdvanceEnergy = (name, AdvanceRule) => {
    const adv = ['9', '11'];

    let advanceEnergyValues = {
        //  isPlasmaBladeX: false,
        //  isAquamantys: false,
    };
    if (
        name === 'Advanced Energy' &&
        AdvanceRule &&
        AdvanceRule !== 'Procedure_Data_Enabled'
    ) {
        let values = AdvanceRule?.metadata.map((items) =>
            String(items)?.trim().toLowerCase()
        );
        adv.filter((aditem) =>
            AdvanceRule?.ruleValue === VISIBLE
                ? values?.includes(aditem)
                : values?.includes(aditem)
        ).map((selectedItem) => {
            if (selectedItem === '11') {
                advanceEnergyValues.isPlasmaBladeX = true;
            } else if (selectedItem === '9') {
                advanceEnergyValues.isAquamantys = true;
            }
        });
        //  advancedEnergyProduct = advanceEnergyValues;
    } else if (name === 'Advanced Energy' && !AdvanceRule) {
        //  obj = obj.filter((item) => !item.description === 'Advanced Energy');
        return false;
    } else if (
        name === 'Advanced Energy' &&
        AdvanceRule === 'Procedure_Data_Enabled'
    ) {
        advanceEnergyValues.isPlasmaBladeX = true;
        advanceEnergyValues.isAquamantys = true;
        //  advancedEnergyProduct = advanceEnergyValues;
    }

    return Object.keys(advanceEnergyValues).length > 0
        ? advanceEnergyValues
        : 'disable';
};
// Displaying Order of Additional procedure data for japan
export const getShowOrder = (obj) => {
    let showOrder = {
        Powerease: 0,
        'Stealth S7/S8 Navigation': 0,
        'Advanced Energy': 0,
        'MazorX Robot Used': 0,
    };
    if (obj.length === 4) {
        return (showOrder = {
            Powerease: 1,
            'Stealth S7/S8 Navigation': 3,
            'Advanced Energy': 5,
            'MazorX Robot Used': 2,
        });
    } else if (obj.length === 3) {
        obj.map((item, index) => {
            if (item.description === 'Powerease') {
                showOrder.Powerease = 1;
            } else if (item.description === 'Stealth S7/S8 Navigation') {
                showOrder['Stealth S7/S8 Navigation'] =
                    showOrder.Powerease === 0
                        ? 1
                        : obj[index + 1]?.description === 'MazorX Robot Used' ||
                            obj[index + 1]?.description === 'Advanced Energy'
                            ? 3
                            : 3;
            } else if (item.description === 'Advanced Energy') {
                showOrder[item.description] =
                    showOrder.Powerease === 0
                        ? 3
                        : showOrder['Stealth S7/S8 Navigation'] === 0
                            ? 3
                            : 2;
            } else {
                showOrder[item.description] = showOrder.Powerease === 0 ? 2 : 2;
            }
        });
    }
    if (obj.length === 2) {
        obj.map((item, index) => {
            if (item.description === 'Powerease') {
                showOrder.Powerease = 1;
            } else if (item.description === 'Stealth S7/S8 Navigation') {
                showOrder['Stealth S7/S8 Navigation'] =
                    showOrder.Powerease === 0 ? 1 : 2;
            } else {
                showOrder[item.description] =
                    showOrder.Powerease === 0
                        ? showOrder['Stealth S7/S8 Navigation'] === 0
                            ? item.description === 'Advanced Energy'
                                ? 1
                                : 2
                            : 2
                        : 2;
            }
        });
    } else {
        showOrder[obj[0]?.description] = 1;
    }

    return showOrder;
};

export const checkSelectAllDisabled = (products, countryISOCode) => {
     if (!Array.isArray(products)) {
        return false;
    }
    let reservationSet = products.filter((d) => d.isReservationSet);
    if (reservationSet.length === products.length && countryISOCode === 'JP') {
        return true;
    } else {
        return false;
    }
};

//disable Procedure page after validating procedure page data
// export const getProcedurePageVisibility = (data, Physician) => {
//     if (
//         data !== null &&
//         data !== undefined &&
//         data?.additionalProcedure[0] === 'ADDITIONAL_PROCEDURE_DATA' &&
//         data?.biologicsUsed[0] === 'BIOLOGICS_USED' &&
//         data?.retractors[0] === 'RETRACTOR_USED' &&
//         data?.technologies[0] === 'DEFORMITY_CORRECTION' &&
//         data?.therapies[0] === 'PHYSICIAN_FINDER_ELIGIBILITY' &&
//         Physician !== 'ENABLED' &&
//         Physician !== undefined
//     ) {
//         return true;
//     } else return false;
// };

export const countTotalBOM = (items) => {
    // Initialize counter for bill of materials
    let totalBOMCount = 0;

    // Iterate through each item
    items?.forEach((item) => {
        // Check if item has productMoreDetails and billOfMaterials
        if (
            item?.productMoreDetails &&
            item?.productMoreDetails?.billOfMaterials
        ) {
            // For each item, multiply the number of BOMs by the item quantity
            totalBOMCount +=
                item?.productMoreDetails?.billOfMaterials?.length *
                item?.quantity;
        }
    });
    items?.forEach((item) => {
        // Check if item has productMoreDetails and billOfMaterials
        if (!item?.isSet) {
            // For each item, multiply the number of BOMs by the item quantity
            totalBOMCount += 1;
        }
    });

    return totalBOMCount;
};

export const getTotalCount = (data) => {
    // Initialize counter for bill of materials
    let totalBOMCount = 0;
    let items = [];
    items = data?.filter((item) => {
        return Object.keys(item).length > 0;
    }) || [];

    // Iterate through each item
    if (items?.length > 0) {
        items?.forEach((item) => {
            // Check if item has productMoreDetails and billOfMaterials
            if (
                item?.productMoreDetails &&
                item?.productMoreDetails?.billOfMaterials
            ) {
                // For each item, multiply the number of BOMs by the item quantity
                item?.productMoreDetails?.billOfMaterials?.forEach((data) => {
                    totalBOMCount += parseInt(data.quantity);
                });
            }
        });
        items?.forEach((item) => {
            // Check if item has productMoreDetails and billOfMaterials
            if (!item?.isSet) {
                // For each item, multiply the number of BOMs by the item quantity
                totalBOMCount += 1 * parseInt(item?.quantity);
            }
        });
    }

    return totalBOMCount;
};

export const getTotalQuantity = (data) => {
    // Initialize counter for bill of materials
    let totalBOMCount = 0;
    let items = [];
    items = data?.filter((item) => {
        return Object.keys(item).length > 0;
    }) || [];

    items?.forEach((item) => {
        totalBOMCount += 1 * parseInt(item?.quantity);
    });

    return totalBOMCount;
};
// export const checkAddItemRules = (rules, items) => {
//     // Create a map of items for easy lookup
//     const itemMap = items.reduce((acc, item) => {
//         acc[item.productCFN] = item.quantity;
//         return acc;
//     }, {});

//     // Check each rule
//     for (const rule of rules) {
//         const itemAQty = itemMap[rule.materialA] || 0;
//         const itemBQty = itemMap[rule.materialB] || 0;
//         // Calculate how many sets of itemA we have
//         const numberOfSets = Math.floor(itemAQty / rule.materialAQty);
//         // Calculate required quantity of itemB based on the sets
//         const requiredBQty = numberOfSets * rule.materialBQty;
//         // If we don't have enough of itemB, return false
//         if (itemBQty < requiredBQty) {
//             return {
//                 satisfied: false,
//                 details: {
//                     rule: rule,
//                     itemAQty,
//                     itemBQty,
//                     requiredBQty,
//                 },
//             };
//         }
//     }
//     return {
//         satisfied: true,
//         details: {
//             message: 'All rules are satisfied',
//         },
//     };
// };
// export const checkAddItemRules = (rules, items) => {
//     // Create a map of items for easy lookup
//     const itemMap = items.reduce((acc, item) => {
//         acc[item.productCFN] = item.quantity;
//         return acc;
//     }, {});
//
//     // Check each rule
//     for (const rule of rules) {
//         const itemAQty = itemMap[rule.materialA] || 0;
//         const itemBQty = itemMap[rule.materialB] || 0;
//         // Calculate how many sets of itemA we have
//         const numberOfSets = Math.floor(itemAQty / rule.materialAQty);
//         // Calculate required quantity of itemB based on the sets
//         const requiredBQty = numberOfSets * rule.materialBQty;
//         // If we don't have enough of itemB, return false
//         if (itemBQty < requiredBQty) {
//             return {
//                 satisfied: false,
//                 details: {
//                     rule: rule,
//                     itemAQty,
//                     itemBQty,
//                     requiredBQty,
//                 },
//             };
//         }
//     }
//     return {
//         satisfied: true,
//         details: {
//             message: 'All rules are satisfied',
//         },
//     };
// };

export const shouldAddItemsToCart = (cartItems, addedItemsState, itemMap) => {
    const normalizeCFN = (value) => String(value ?? '').trim().toUpperCase();

    const sumUserParentQtyByCFN = (items, cfn) => {
        const key = normalizeCFN(cfn);
        if (!key) return 0;
        return (items ?? []).reduce((sum, item) => {
            const itemKey = normalizeCFN(item?.productCFN ?? item?.cfn);
            if (itemKey !== key) return sum;
            if (item?.isAddItemRuleProduct === true) {
                return sum + (Number(item?.userAddedQuantity) || 0);
            }
            return sum + (Number(item?.quantity) || 0);
        }, 0);
    };

    const effectiveItemMap =
        itemMap ||
        (cartItems ?? []).reduce((acc, item) => {
            const key = normalizeCFN(item?.productCFN ?? item?.cfn);
            if (!key) return acc;
            const qty = Number(item?.quantity) || 0;
            acc[key] = (acc[key] ?? 0) + qty;
            return acc;
        }, {});

    // Tracks Material B already allocated to earlier rules sharing the same
    // Material B, so multiple distinct Material A items each get their own
    // required Material B instead of sharing a single one.
    const consumedBByKey = {};
    // Avoid evaluating the same (materialA, materialB, qty) rule more than once
    // when it is duplicated across several cart lines.
    const evaluatedRuleKeys = new Set();

    for (const item of cartItems ?? []) {
        if (
            item?.isAddItemRuleProduct === true &&
            !(Number(item?.userAddedQuantity) > 0)
        ) {
            continue;
        }
        if (!item?.addItemRules || item.addItemRules.length === 0) continue;

        for (const rule of item.addItemRules) {
            if (
                rule?.setMaterialQualifier &&
                (effectiveItemMap[rule.setMaterialQualifier] || 0) > 0
            ) {
                continue;
            }

            const materialA = rule?.materialA;
            const materialB = rule?.materialB;
            const materialAQty = parseInt(rule?.materialAQty, 10);
            const materialBQty = parseInt(rule?.materialBQty, 10);

            if (!materialA || !materialB || !materialAQty || !materialBQty) {
                continue;
            }

            const materialAKey = normalizeCFN(materialA);
            const materialBKey = normalizeCFN(materialB);

            const ruleKey = `${materialAKey}|${materialBKey}|${materialAQty}|${materialBQty}`;
            if (evaluatedRuleKeys.has(ruleKey)) continue;
            evaluatedRuleKeys.add(ruleKey);

            const aQty = sumUserParentQtyByCFN(cartItems, materialAKey);
            const bQtyInCart = effectiveItemMap[materialBKey] || 0;

            // addedItemsState represents a "pending/expected total" in some flows; treat it as a floor (never smaller than cart totals)
            const pendingBQty =
                Number(addedItemsState?.[materialBKey]?.addedQuantity) || 0;
            const baseBQty = Math.max(bQtyInCart, pendingBQty);
            const credit = Number(addedItemsState?.[materialBKey]?.decreaseCredit) || 0;
            const totalEffectiveBQty = baseBQty + credit;

            const requiredBQty = checkRequiredQTY(aQty, materialAQty, materialBQty);

            // Only the Material B not yet claimed by other rules can satisfy this one.
            const alreadyConsumed = consumedBByKey[materialBKey] || 0;
            const availableBQty = Math.max(0, totalEffectiveBQty - alreadyConsumed);
            const consumedForThisRule = Math.min(availableBQty, requiredBQty);
            consumedBByKey[materialBKey] = alreadyConsumed + consumedForThisRule;

            if (consumedForThisRule < requiredBQty) {
                return true;
            }
        }
    }

    return false;
};

export const checkWarningMessageInSets = (cartProducts, cfn) => {
    let firstMatchFound = false;
    if (cartProducts.length === 1) {
        return true;
    }

    for (const product of cartProducts) {
        if (firstMatchFound) {
            firstMatchFound = 'yes';
        }

        if (product?.productCFN === cfn && product?.isSet === true) {
            if (firstMatchFound !== 'yes') {
                firstMatchFound = true;
            }
            if (firstMatchFound && firstMatchFound !== 'yes') {
                continue;
            }

            const hasMessage = product?.businessRules.some(
                (rule) => rule?.message && rule.message.trim() !== ''
            );

            if (hasMessage) {
                return false;
            }

            return true;
        }
    }

    // Return true if no matching product or isSet is false
    return true;
};

export const checkRequiredQTY = (materialAQty, baseQty, materialBQty) => {
    let totalRequiredB = 0;
    const sets = Math.ceil(materialAQty / baseQty);
    totalRequiredB += sets * materialBQty;
    return totalRequiredB;
};

export const avoidDeploymentType = (countryISOCode) => {
    if (countryISOCode !== US_COUNTRY_CODE) return true;
    else return false;
};

export const itemListViewVisibility = (orderType) => {
    if (orderType === 'ZLB' || orderType === 'ZLC') return true;
    else return false;
};

export const resetPricesForSingleItems = (itemList, cfn) => {
    if (!Array.isArray(itemList)) {
        return [];
    }
const result = itemList.filter((product) => product.productCFN !== cfn);
    return result;
};

export const getAccountDetails = (items) => {
    return items.map(
        (item) => item?.shippingDetails?.accountDetails?.timeZoneOffset
    );
};

export const checkNonEMEASalesOrg = (salesOrg) => {
    return ['S002', 'S030', 'S024', 'S040', 'S041'].includes(salesOrg);
};

export const checkConditionsNoItems = (data) => {
    if (
        data?.[0]?.isImplantable === false &&
        data?.[0]?.isInstrument === false &&
        data?.[0]?.isSet === false
    ) {
        return false;
    }
    return true;
};

export const removeFirstPopup = (stack, stackSetter) => {
    const updatedStack = [...stack];
    updatedStack.splice(0, 1);
    stackSetter(updatedStack);
};

export const isSameDay = (date1, date2) =>
    new Date(date1).setHours(0, 0, 0, 0) ===
    new Date(date2).setHours(0, 0, 0, 0);

export const isBeforeToday = (date) =>
    new Date(date).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0);

export const reorderMazorX = (fields, reference) => {
    // Step 1: Match by description if length differs
    let filteredFields = [...fields];
    if (reference?.length === 5) return fields;
    if (fields?.length !== reference?.length) {
        const refDescriptions = reference?.map((r) => r.description);
        filteredFields = filteredFields?.filter((item) =>
            refDescriptions.includes(item)
        ) || [];
    }
    const advanceIndex = filteredFields?.findIndex(
        (item) => item === 'Advanced Energy'
    );
    if (advanceIndex !== -1 && filteredFields?.length > 1) {
        const [advanceItem] = filteredFields.splice(advanceIndex, 1);
        const newIndex =
            reference.length === 4
                ? 3
                : reference.length === 3
                    ? 2
                    : reference.length === 5
                        ? 2
                        : reference.length - 1;
        filteredFields.splice(newIndex, 0, advanceItem);
    }

    // Step 2: Reorder "MazorX Robot Used" if more than 1 item
    const mazorIndex = filteredFields.findIndex(
        (item) => item === 'MazorX Robot Used'
    );

    if (mazorIndex !== -1 && filteredFields.length > 1) {
        const [mazorItem] = filteredFields.splice(mazorIndex, 1);
        const newIndex = reference.length === 5 ? 3 : 1;
        filteredFields.splice(newIndex, 0, mazorItem);
    }

    return filteredFields;
};
export const debounce = (func, delay) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
    };
};

export const closekeyBoard = () => {
    document.activeElement.blur();
};


export const logErrorToConsole = (error) => {
    if (ERROR_BOUNDARY_STATUS) {
        console.error(error);
    }
};

export const setUserData = (response) => {
    sessionStorage.setItem('employeeRole', response.employeeRole);
    localStorage.setItem('baseSiteId', response.baseSiteId || BASESITEID);
    localStorage.setItem(
        'currencyISOCode',
        response.currencyISOCode || US_CURRENCY_CODE
    );
    localStorage.setItem(
        'languageISOCode',
        response.languageISOCode || US_LANGUAGE_CODE
    );
    localStorage.setItem(
        'countryISOCode',
        response.countryISOCode || US_COUNTRY_CODE
    );
    localStorage.setItem(
        'salesOrg',
        response?.salesOrgs 
    );
    updateCurrencyCode(response.currencyISOCode || US_CURRENCY_CODE);
};

export const setMyCaseRef = (myCaseRef) => { 
    localStorage.setItem(
        'myCaseRefId',
        myCaseRef
    );
}
export const prevStartDate = { current: null };
export const prevEndDate = { current: null };


export  const validateAllParams = (params, excludeFields = []) => {
    return Object.entries(params).every(([key, value]) => {
        if (excludeFields.includes(key)) {
            return true;
        }
        if (value === null || value === undefined || value === '') {
            return false;
        }
        if (typeof value === 'object' && !Array.isArray(value)) {
            return false;
        }
        return true;
    });
};
export const getBrowserName = () => {
    const userAgent = navigator.userAgent;
    if (userAgent.includes('Firefox/')) return 'Firefox';
    if (userAgent.includes('Edg/')) return 'Edge';
    if (userAgent.includes('Chrome/')) return 'Chrome';
    if (userAgent.includes('Safari/') && !userAgent.includes('Chrome/')) return 'Safari';
    if (userAgent.includes('Opera/') || userAgent.includes('OPR/')) return 'Opera';
    return 'Unknown';
};

export const getCartProductQuantityMap = (products) => {
    if (!Array.isArray(products)) return {};

    return products.reduce((acc, item) => {
        const productCFN = item?.productCFN;
        if (!productCFN) return acc;

        acc[productCFN] = item?.quantity || 0;
        return acc;
    }, {});
};

export const syncAddedItemsStateWithCartForRules = (
    prevState,
    addItemRules,
    cartQuantityMap
) => {
    if (!addItemRules || addItemRules?.length === 0) return prevState;

    const safePrevState = prevState || {};
    const itemMap = cartQuantityMap || {};

    let changed = false;
    const nextState = { ...safePrevState };

    addItemRules.forEach((rule) => {
        const materialB = rule?.materialB;
        if (!materialB) return;

        const cartBQty = itemMap?.[materialB] || 0;
        const prevAddedQty = safePrevState?.[materialB]?.addedQuantity;

        if (cartBQty === 0 && prevAddedQty && prevAddedQty !== 0) {
            nextState[materialB] = {
                ...safePrevState?.[materialB],
                addedQuantity: 0,
            };
            changed = true;
        }

        // Keep tracking in sync when B exists in the cart (covers manual adds)
        if (cartBQty > 0 && (!prevAddedQty || prevAddedQty < cartBQty)) {
            nextState[materialB] = {
                ...safePrevState?.[materialB],
                addedQuantity: cartBQty,
            };
            changed = true;
        }
    });

    return changed ? nextState : safePrevState;
};

export const getCartCount = (cartProducts, data, hasLotSerial, isTemplate=false) => {
    const normalizeLotSerial = (lotSerial) => {
        if (Array.isArray(lotSerial)) {
            return lotSerial;
        }

        if (lotSerial && typeof lotSerial === 'object') {
            return [lotSerial];
        }

        return [];
    };

    const getLotSerialUsedCount = (lotSerial = []) => {
        const normalizedLotSerial = normalizeLotSerial(lotSerial);

        return normalizedLotSerial.reduce((total, item) => {
            const usedValue = item?.Used ?? item?.used;
            const otherValue = item?.Other ?? item?.other;

            let usedCount = 0;
            if (usedValue === true) {
                usedCount = 1;
            } else if (
                usedValue !== undefined &&
                usedValue !== null &&
                !(usedValue === false || usedValue === '' ||
                (typeof usedValue === 'string' && usedValue.trim() === ''))
            ) {
                const parsed = parseInt(usedValue, 10);
                usedCount = isNaN(parsed) ? 0 : parsed;
            }

            let otherCount = 0;
            if (otherValue === true) {
                otherCount = 1;
            } else if (
                otherValue !== undefined &&
                otherValue !== null &&
                !(otherValue === false || otherValue === '' ||
                (typeof otherValue === 'string' && otherValue.trim() === ''))
            ) {
                const parsed = parseInt(otherValue, 10);
                otherCount = isNaN(parsed) ? 0 : parsed;
            }

            return total + usedCount + otherCount;
        }, 0);
    };

    const hasLotSerialUsedValue = (lotSerial = []) => {
        const normalizedLotSerial = normalizeLotSerial(lotSerial);

        if (normalizedLotSerial.length === 0) {
            return false;
        }

        return normalizedLotSerial.some((item) => {
            const usedValue = item?.Used ?? item?.used;
            const otherValue = item?.Other ?? item?.other;
            const hasUsed =
                usedValue !== undefined &&
                usedValue !== null &&
                !(typeof usedValue === 'string' && usedValue.trim() === '');
            const hasOther =
                otherValue !== undefined &&
                otherValue !== null &&
                !(typeof otherValue === 'string' && otherValue.trim() === '');
            return hasUsed || hasOther;
        });
    };

    if (Array.isArray(cartProducts) && hasLotSerial) {
        return cartProducts.reduce(
            (result, product) => {
                const isMatchingProduct =
                    (((product?.cfn || product?.productCFN) === data?.cfn) &&
                    (product?.salesOrg === '' || (product?.salesOrg === data?.salesOrg) ));
                const lotSerialData = product?.lotSerial ?? product?.lotserial;
                if (!isMatchingProduct) {
                    return result;
                }

                const uniqueKey = product?.uniqueKey || product?.unqId || product?.id;

                if (uniqueKey && result.processedUniqueKeys.has(uniqueKey)) {
                    return result;
                }

                if (uniqueKey) {
                    result.processedUniqueKeys.add(uniqueKey);
                }

                const lotSerialCount = hasLotSerialUsedValue(lotSerialData)
                    ? getLotSerialUsedCount(lotSerialData)
                    : normalizeLotSerial(lotSerialData).length > 0
                        ? getLotSerialUsedCount(lotSerialData)
                        : 0;

                result.count += lotSerialCount > 0
                    ? lotSerialCount
                    : parseInt(product?.usedQuantity || product?.quantity || 1, 10);
                return result;
            },
            { count: 0, processedUniqueKeys: new Set() }
        ).count;
    }

    return Array.isArray(cartProducts)
        ? cartProducts.reduce((count, product) => {
                  const isMatchingProduct =
                      (product?.cfn || product?.productCFN) === data?.cfn &&
                      (product?.salesOrg === data?.salesOrg) &&
                      (!isTemplate || (isTemplate && !product.isTemplateEntryDeleted));

                  if (!isMatchingProduct) {
                      return count;
                  }

                  if (data?.isSet) {
                      return count + 1;
                  }

                  const qty = product?.usedQuantity ?? product?.quantity ?? 1;
                  return count + parseInt(qty, 10);
              }, 0)
        : 0;
};

export const arraysEqual = (arr1, arr2) => {
    const a = arr1 || [];
    const b = arr2 || [];
    if (a.length !== b.length) return false;
    return a.every(item => b.includes(item)) && b.every(item => a.includes(item));
}; 
